<!--创建/编辑活动-->
<script>
import serverConfig from "@/utils/config/index.js";
import { imageUrl } from "@/utils/config/commonUrl.js";
import {
    clockPresetsList, clockPresetsDel,
    clockPresetsDetail, clockPresetsAdd,
    clockPresetsUpdate, activityDetail, updateActivity, updateSignList, isUpdateSignList,
    getCoverimgTemplate, getSignList, getProjectManageAdmin
} from "@/utils/api/build";
import { getCreateList ,updateActivitySignList} from "@/utils/api/activity";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import CustomDialogHeader from "@/components/CustomDialogHeader.vue";

import axios from 'axios';
import router from "../../../router";
import { mapActions, mapState } from 'vuex'

var dayjs = require('dayjs')

export default {
    page: {
        title: "群通知",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, CustomDialogHeader },
    data() {
        return {
            title: "Basic Tables",
            items: [
                {
                    text: "Tables",
                    href: "/"
                },
                {
                    text: "Basic",
                    active: true
                }
            ],
            drawer: true,
            direction: 'rtl',
            options: [{
                value: '选项1',
                label: '黄金糕'
            }, {
                value: '选项2',
                label: '双皮奶'
            }, {
                value: '选项3',
                label: '蚵仔煎'
            }, {
                value: '选项4',
                label: '龙须面'
            }, {
                value: '选项5',
                label: '北京烤鸭'
            }],
            value: '',
            checked: true,
            value1: '',
            input: '',
            radio: '1',
            dialogImageUrl: '',
            dialogVisible: false,
            fileList: [{ name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }, { name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }],
            value2: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
            candidateList: [],// 选中的周几
            value3: '',

            map: null,
            point: null,
            markerPoint: {
                address: '',

            },
            location: { lng: 116.403963, lat: 39.915119 },  // 地图中心点
            zoom: 19,  // 地图缩放级别
            markLocation: {  // 标记点的经纬度
                lng: 116.403963, lat: 39.915119
            },
            form: {
                address: '', // 详细地址
                addrPoint: { // 详细地址经纬度
                    lng: 0,
                    lat: 0
                }
            },
            mk: '', // Marker实例
            value4: '',

            addressDialog: false,
            addressIdx: null,

            poiname: '', //地址名称
            longitude: '', //纬度
            latitude: '', //经度


            // -----------------------------------------------------------------------------
            // 基础设置
            isType: '201', //创建活动的类型
            groupId: '', //群组id
            // 详细信息
            activityDetail: {
                name: '',
                content: '',
            },
            modularList: [], // 模块列表
            modular1: [], // 模块列表
            indexIdx: 0,
            commonDisabled: false, // 是否可以编辑
            formDrawerShow: false,
            actStartAndEndTime: '',
            // 表单项 类别
            formList: [
                {
                    label: '姓名',
                    type: 0,
                },
                {
                    label: '手机号',
                    type: 1,
                },
                {
                    label: '数量',
                    type: 2,
                },
                {
                    label: '文件',
                    type: 25,
                },
                {
                    label: '签名',
                    type: 24,
                },
                // {
                //     label: '水印拍照',
                //     type: 23,
                // },
                {
                    label: '日期/时间',
                    type: 3,
                },
                {
                    label: '图片',
                    type: 4,
                },
                {
                    label: '身份证',
                    type: 5,
                },
                // {
                //     label: '时间',
                //     type: 6,
                // },
                {
                    label: '定位',
                    type: 7,
                },
                {
                    label: '省/市/区',
                    type: 8,
                },
                {
                    label: '性别',
                    type: 9,
                },
                {
                    label: '音频',
                    type: 12,
                },
                {
                    label: '视频',
                    type: 13,
                },
                {
                    label: '邮箱',
                    type: 14,
                },
                {
                    label: '学校',
                    type: 15,
                },
                {
                    label: '院系',
                    type: 16,
                },
                {
                    label: '工号',
                    type: 17,
                },
                {
                    label: '学号',
                    type: 18,
                },
                {
                    label: '公司',
                    type: 19,
                },
                {
                    label: '职位',
                    type: 20,
                },
                {
                    label: '部门',
                    type: 21,
                },
                // {
                //     label: '单位',
                //     type: 22,
                // },
                {
                    label: '时间区间',
                    type: 31,
                },
            ],
            // 报名字段
            listList: [{
                signListName: '',
                ifDel: 2,
                addTime: '',
                signField: [

                ],
            }],

            storgeName: [],
            // ---------------------------------------------------------------------------------
            // 打卡内容
            formClock: {
                clockFrequencyName: '每天', //打卡要求
                clockRemindStatus: 1, //打卡提醒开关 1 开 2关
                remindTime: '10:00', //打卡提醒时间
                beginTime: '00:00', //打卡开始时间
                endTime: '23:59', //打卡结束时间
                clockSupplyStatus: 1, //补卡开关  1 开 2关
                supplyTimes: '-1', //补卡次数
                clockLocationStatus: 2,  //是否指定打卡地点 1 开 2关
                clockRange: 1000, //打卡范围
                clockFrequency: '0,1,2,3,4,5,6', //打卡要求 周、每天
                // 新加的 有用的
                clockLocationInfo: '',  //打卡地点信息
                clockFrequencyType: '3', // 打卡频率类型！！！！！
                clockMaxNum: 1, // 每周、每月打卡 最大次数
                clockMaxSwitch: 2, // 每周、每月最大值开关
                dayOfDate: '', // 每周、每月打卡截止—周几或几号，根据clockFrequencyType变化（周几 存的是 0、1、2、3、4、5、6   月：几号就是几，不变）
                timeOfDay: '', // 每周、每月打卡截止—时分秒
                multiPeriodSwitch: 2, // 多时段打卡开关
                clockInTimeSlot: [
                    {
                        startTime: "00:00",
                        endTime: "23:59",
                        ifDel: 2, // 删除是1，未删除是2
                        randomDecimal: Date.now(),
                    },
                ],
                customDate: '', // 自定义日期 逗号拼接的
                clockSupplyType: -1, //补卡频率类型 0 总共  1=每月｜2=每周｜3=每天 | -1 不限制次数
            },
            clockFrequencyName: '',
            markers: {},
            range: '1',
            address: '',
            clockRange: 1000,
            selectData: '每天',
            starttime: '00:00',
            endtime: '23:59',
            show: false,
            show2: false,
            color: '#1877FF',
            candidates: [
                { name: '星期一', value: '0', checked: false },
                { name: '星期二', value: '1', checked: false },
                { name: '星期三', value: '2', checked: false },
                { name: '星期四', value: '3', checked: false },
                { name: '星期五', value: '4', checked: false },
                { name: '星期六', value: '5', checked: false },
                { name: '星期日', value: '6', checked: false }
            ],

            columns3: [["1000米以内", "500米以内", "200米以内", "100米以内", "50米以内"]],
            dakaColumnsArr: [
                {
                    label: '1000米以内',
                    value: 1000,
                },
                {
                    label: '500米以内',
                    value: 500,
                },
                {
                    label: '200米以内',
                    value: 200,
                },
                {
                    label: '100米以内',
                    value: 100,
                },
            ],
            clockRangeList: [
                {
                    name: '不限制次数',
                    value: -1
                },
                {
                    name: '「总共」可补卡次数',
                    value: 0
                },
                {
                    name: '「每天」可补卡次数',
                    value: 3
                },
                {
                    name: '「每周」可补卡次数',
                    value: 2
                },
                {
                    name: '「每月」可补卡次数',
                    value: 1
                },
            ],
            disbandBox: false,
            city: '',
            current: 0,
            selectFrequency: 3, // 频率类型 1=每月｜2=每周｜3=每天｜4=法定工作日｜5=法定节假日｜6=自定义周几打卡｜7=自定义日期打卡 | 8=一次性打卡
            lastDayOfMonth: '',
            weekChineseNumbers: ['一', '二', '三', '四', '五', '六', '日'],
            endMonthShow: false,
            endMonthArr: [
                [],
                [],
                []
            ],
            endMonthArr1: [],
            endMonthArr2: [],
            endMonthArr3: [],
            endMonthValue: '',
            endWeekShow: false,
            endWeekArr: [
                ['一', '二', '三', '四', '五', '六', '日'],
                [],
                []
            ],
            endWeekArr1: [
                {
                    label: '周一',
                    value: 0,
                },
                {
                    label: '周二',
                    value: 1,
                },
                {
                    label: '周三',
                    value: 2,
                },
                {
                    label: '周四',
                    value: 3,
                },
                {
                    label: '周五',
                    value: 4,
                },
                {
                    label: '周六',
                    value: 5,
                },
                {
                    label: '周日',
                    value: 6,
                }
            ],
            endWeekArr2: [],
            endWeekArr3: [],

            endWeekValue: '',
            modeRili: 'multiple',
            cusRilishow: false,
            customDateArr: [],
            // 打卡频率
            CheckInFrequency: [
                {
                    label: '每月',
                    value: 1,
                },
                {
                    label: '每周',
                    value: 2,
                },
                {
                    label: '每天',
                    value: 3,
                },
                {
                    label: '法定工作日',
                    value: 4,
                },
                {
                    label: '法定节假日',
                    value: 5,
                },
                {
                    label: '自定义周几打卡',
                    value: 6,
                },
                {
                    label: '自定义日期打卡',
                    value: 7,
                },
                {
                    label: '一次性打卡',
                    value: 8,
                },

            ],
            monthDay: 0,
            monthHour: 0,
            monthMinute: 0,
            weekDay: 1,
            weekHour: 1,
            weekMinute: 0,
            // 时间段
            timeSlotArr: ['00:00', '23:59'],
            selectedFile: null,
            modulCommonIndex: 0,
            imageUrl: imageUrl,
            modularDelIds: [],
            // 查看活动类型
            selectType: 'add', //add
            delListInfo: [],
            activityId: '1',
            previewImgSrc: '', // 图片路径
            previewImgShow: false,
            isModular: false,
            addMapType: 1, // 2-模块 3-设置 1-打卡
            imageUploadLimit: 9,
            imgUpMoveSrc: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png',
            imgDownMoveSrc: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png',
            imgCancelSrc: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png',

            // 高级设置
            shareStatus: '',
            commentStatus: 2,
            confirmWord: '参加接龙',
            select_type: "",
            activityType: 0,
            isanonymous: 1,
            publisher: localStorage.getItem('jlnickname'),
            remindtime: '00:00',
            edit_publisher: '',
            columns1: [
                ['不允许修改', '自定义修改时间', '接龙终止前']
            ],
            // 允许修改报名信息
            updateSignInfo: 3, // 是否允许修改 1、活动结束前可以  2、不可以取消 3、时间段内可以
            updateSignArr: [
                {
                    label: '不允许修改',
                    value: 1,
                },
                {
                    label: '自定义修改时间',
                    value: 2,
                },
                {
                    label: '接龙终止前',
                    value: 3,
                },

            ],
            columns1Show: false,
            columns2: [
                ['不允许删除', '自定义删除时间', '接龙终止前']
            ],
            removeSignStatus: 4,
            cancellation: [
                ['活动终止前', '不可取消', '自定义', '允许取消']
            ],
            cancellationArr: [
                {
                    label: '活动终止前',
                    value: 1,
                },
                {
                    label: '不可取消',
                    value: 2,
                },
                {
                    label: '自定义',
                    value: 3,
                },
                {
                    label: '允许取消',
                    value: 4,
                },

            ],
            columns2Show: false,
            anonymousparticipation: 0,

            submitcopy: '参加接龙',
            edit_submit_btn: '',
            edit_partin_btn: '',
            is_notice: 0,// 接龙通知
            is_forward: 0,//转发
            is_remind: 0,//接龙提醒
            cancelTitle: '接龙终止前',
            endregistrationtime: null,
            registrationtime: null,
            zdyTimes: false,
            zdyTimesEnd: false,
            zdyDelTimes: false,
            zdyDelTimesEnd: false,
            enddeletingtime: null,
            startdeletingtime: null,
            delSignTitle: '不允许删除',
            deleteregistration: 1,//是否允许删除报名信息1不允许 ，2自定义，3活动结束前
            is_signUpSet: false,//报名信息设置
            is_destination: 0,
            deliveryaddress: '',
            newSeniorSetInfo: {},
            informationswitch: false,//报名信息设置开关
            custombutton: false,//自定义按钮设置开关
            addresscolumns: [["2000米以内", "1500米以内", "1000米以内", "500米以内", "200米以内", "100米以内"]],//打卡范围 数组
            addresscolumnsArr: [
                {
                    label: '2000米以内',
                    value: 2000,
                },
                {
                    label: '1500米以内',
                    value: 1500,
                },
                {
                    label: '1000米以内',
                    value: 1000,
                },
                {
                    label: '500米以内',
                    value: 500,
                },
                {
                    label: '200米以内',
                    value: 200,
                },
                {
                    label: '100米以内',
                    value: 100,
                },
            ],
            addressShow: false,
            clockRange1: '',//打卡范围
            checkinrange: '',//打卡范围
            specifyaddress: '',//
            ifcopy: false,//是否为复制活动
            is_comment: 1,//点评
            is_score: 1,//评分
            signInfoStatus: 1,//报名信息展示
            isContentFocus: true,
            isInputContentFocus: false,
            isFocus: false,
            modelContentFocus: false,
            modelContentbind: true,
            ishandleFocus: false,
            is_template: '0', // 1-模板 0-不是模板是活动
            valueId: null,//点击输入框索引
            valueId2: null,
            valueId3: null,
            valueId4: null,
            valueId5: null,
            valueId6: null,
            valueId7: null,
            valueId8: null,
            selected1: false,
            selected2: false,
            valueindex: null,
            valueindex1: null,
            selectedItem: null,
            copyStatus: 2, // 是否运行他们复制
            ctStartAndEndTime: '',
            deadline: '',
            deadCancelline: '',
            interdict_people_num: 0, // 人数限制

            seniorShow: false,
            openNameListDrawer: false,
            nameShowContent: '',
            people_num: 0,
            importVisible: false,
            nameListDrawer: false,
            addNameListDrawer: false,
            customizeDrawer: false,
            clockInList: [], // 预存名单
            presetsList: [], // 名单管理列表
            clockShowPresetTitle: '',
            clockShowPresetContent: '',
            nameId: '',
            people_num2: '',
            copywriting: '',
            copyimage: '',
            copyShowWriting: '',
            copyShowImage: '',
            is_draft: 0, // 是否是草稿，0不是 1是草稿
            isrepeatClick: false, //防止连续点击创建
            showName: '列表接龙',
            baseurl: '',
            multipleActivitiesStatus: 1, //是否允许参加多项活动 1、允许参加多项活动  2、不允许参加多项活动
            routeParameter: '', // 链接参数
            pageType: '',
            imgInfo: [],
            isOtherPeople: '', // 1=创建者、2=管理员、3=普通用户
            loadingShow: {},
            activeBuildTitle: '通用接龙',
            musicLink: '',
            musicDialog: false,
            fileIframeShow: false,
            fileUrl: '',
            relatedList: [],
            selectedItems: [],
            totalRow: 0,
            pages: 0,
            pageNum: 1,
            relatedDrawerShow: false,
            propertySetShow: false,
            // 格式验证
            validateArr: ['不限格式', '仅中文', '仅英文', '仅数字', '英文+数字', '中文+数字', '中文+英文', '身份证号', '手机号', '座机号', '邮箱', '网址'],
            validateIndex: 0,
            commValue: '',
            commType: '',
            commIndex: '',
            checkboxList1: [
                {
                    name: '保密',
                    checked: false
                },

                {
                    name: '必填',
                    checked: false
                },
                {
                    name: '公开',
                    checked: false
                }
            ],
            checkboxValue1: [],
            commonImgSrc: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/',
            dateSetList: [
                {
                    type: 0,
                    value: '09:00 ~ 10:00',
                    checked: false
                },
                {
                    type: 1,
                    value: '2024-12 ~ 2025-01',
                    checked: false
                },
                {
                    type: 2,
                    value: '2024-12-12 ~ 2025-01-01',
                    checked: false
                },
                {
                    type: 3,
                    value: '2024-02-02 09:00 ~ 2024-08-02 19:00',
                    checked: false
                },
            ],
            timeSetList: [
                {
                    type: 0,
                    value: '23:59:59',
                    checked: false
                },
                {
                    type: 1,
                    value: '2024-05',
                    checked: false
                },
                {
                    type: 2,
                    value: '2024-05-01',
                    checked: false
                },
                {
                    type: 3,
                    value: '2024-05-01 23:59:59',
                    checked: false
                },
            ],
            areaSetList: [
                {
                    type: 0,
                    value: '省',
                    checked: false
                },
                {
                    type: 1,
                    value: '省/市',
                    checked: false
                },
                {
                    type: 2,
                    value: '省/市/区',
                    checked: false
                },
                {
                    type: 3,
                    value: '省/市/区/详细地址',
                    checked: false
                },
            ],
            displayStyleArr: [
                {
                    value: 1,
                    label: '下拉式'
                },
                {
                    value: 2,
                    label: '列表式'
                }
            ],
            wenHaoImgSrc: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bd-build-wenhao.svg',
            propertyData: {},
            selectOptionList: [
                {
                    name: '拍摄照片'
                },
                {
                    name: '从相册选取'
                },
                {
                    name: '从微信聊天中选取'
                }
            ],
            selectOptionShow: false,
            showOptionList: [
                {
                    name: '列表式'
                },
                {
                    name: '下拉式'
                }
            ],
            showOptionShow: false,
            optionName: '列表式',
            imgNumShow: false,
            imgNumArr: [
                [1, 2, 3, 4, 5, 6, 7, 8, 9]
            ],
            lineCopywriting: '',
            maxShow: false,
            maxValueArr: [
                {
                    value: 0,
                    label: '不限'
                },
                {
                    value: 1,
                    label: '1'
                }
            ],
            minShow: false,
            minValueArr: [
                {
                    value: 0,
                    label: '不限'
                },
                {
                    value: 1,
                    label: '1'
                }
            ],
            studyContent: '',
            modelContentDel: false,
            placeholderContent: '',
            tipsPH: '请输入提示内容或说明（选填）',
            tipsContent: '',
            taShow: false,
            scrollHandler: '',
            isLoading: false,
            imageUploadNumArr: [1, 2, 3, 4, 5, 6, 7, 8, 9],
            batchOptionShow: false,
            isInFolder: 1, // 是否在文件夹内 默认 1 否 2 是
            folderId: '', // 文件夹ID
            nameAddOptions: [
                {
                    name: '设定姓名'
                },
                {
                    name: '设定分组'
                },
            ],
            nameAddOptionsShow: false,
            nameAddType: 1, // 1姓名还是2分组
            subsetShow: false,
            // 分组弹框中间值
            subsetCenterValueArr: [],
            subsetValueArr: [], // 给后台的值
            filteredArr: [], // 过滤用
            commFzInfo: {},
            commFzIndex: 0,
            fzPopItemInfo: {}, // 弹框中间值
            fzTitle: '', // 弹框中间值
            fzValue: '', // 弹框中间值
            fzNameArr: [],
            packetData: [], // 展示再页面的分组数据
            pickerName: '全部',
            pickerNameSelectShow: false,
            pickerNameSelectArr: [], // 中间值
            pickerNameSelect: 0,
            nameListLength: 0, // 名单人数
            tableData: [
                { name: '张三', studentId: '' },
                { name: '李四', studentId: '' },
                { name: '王五', studentId: '' }
            ],
            showModal: false,
            placeholderText1: '',
            isAi: "0",
            clockNameNumberSwitch: '1',//是否开启学号/编号 1开启 2关闭
            editImgSrc: 'https://ossfastmake.mustke.com/12jielong/lsyJL/edit.svg',
            subtractFzImgSrc: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/subtractFz.png',
            addFzImgSrc: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/addFz.png',
            handleSubShow: false,
            downloadBoxShow: false,
            beginTime: '',
            foreverValidChecked: false,
            clockSupplyText: '不限制次数',
            clockSupplyShow: false,
            clockSupplyCenterText: '',
            supplyTxt: '',
            isDelSignInfoPop: false,
            isDelOrder: '',
            signFieldClone: [],
            thumbs_up: 1,//点赞 1开 2关
            autographSwitch: 2, // 签名 1开 2关
            onlyNameArr: [],
            activityKey: '',
            clockSwitch: 1, // 默认1关闭2开启.
            nameOrGroup: 1, // 1姓名还是2分组
            onlyGroupArr: [],
            clockListNumber: 5, // 一行展示多少个参与名单 2一排两个 1一排三个，以此类推

            clockListNumArr: [
            {
                value: 2,
                label: "一排2个",
            },
            {
                value: 3,
                label: "一排3个",
            },
            {
                value: 4,
                label: "一排4个",
            },
            {
                value: 5,
                label: "一排5个",
            },
            ],
            demonVisible: false,
            contentList: {

            },



        };
    },
    mounted() {
        var str11 = dayjs().format('DD/MM/YYYY');
        // 页面参数
        this.routeParameter = this.$route.query;
        if (this.routeParameter.activityId) {
            this.activityId = this.routeParameter.activityId;
        }
        if (this.routeParameter.alias) {
            this.activityKey = this.routeParameter.alias;
        }
        if (this.routeParameter.selectType) {
            this.selectType = this.routeParameter.selectType;
        }
        if (this.routeParameter.is_template) {
            this.is_template = Number(this.routeParameter.is_template); // 1-模板 0-不是模板是活动
        }
        if (this.routeParameter.selectType) {
            this.selectType = this.routeParameter.selectType;
        }
        if (this.routeParameter.folderId) {
            this.folderId = this.routeParameter.folderId;
            // 在文件夹内创建，isInFolder 设置为 2
            this.isInFolder = 2;
        }
        if (this.routeParameter.isInFolder) {
            this.isInFolder = this.routeParameter.isInFolder;
        }

        this.pageType = this.routeParameter.pageType;
        this.ifcopy = this.routeParameter.copy;
        this.groupId = this.routeParameter.groupId;
        if (this.isType == 201) {
            this.activeBuildTitle = '群通知'
        }

        this.subAddress()
        this.lastDayOfMonth = this.getLastDayOfMonth()
        // 截止赋值
        var arr1 = [];
        for (var i = 1; i <= 31; i++) {
            var str = i + '号';
            var _json = {
                value: i,
                label: str
            }
            arr1.push(_json);
        }
        this.endMonthArr1 = arr1;

        var arr2 = [];
        for (var j = 0; j <= 23; j++) {
            if (j < 10) {
                var timeJson1 = {
                    value: j,
                    label: '0' + j + '时'
                }
                arr2.push(timeJson1);
            } else {
                var timeJson2 = {
                    value: j,
                    label: j + '时'
                }
                arr2.push(timeJson2);
            }
        }
        this.endMonthArr2 = arr2;
        this.endWeekArr2 = arr2;

        var arr3 = [];
        for (var g = 0; g <= 59; g++) {
            if (g < 10) {
                var timeJson3 = {
                    value: g,
                    label: '0' + g + '分'
                }
                arr3.push(timeJson3);
            } else {
                var timeJson4 = {
                    value: g,
                    label: g + '分'
                }
                arr3.push(timeJson4);
            }
        }
        this.endMonthArr3 = arr3;
        this.endWeekArr3 = arr3;

        this.activityDetailFun()
        this.coverimgClone()



    },
    watch: {
        relatedDrawerShow(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    const scrollableDiv = document.getElementById('scrollable-div');
                    if (scrollableDiv) {
                        this.scrollHandler = (event) => {

                            this.isLoading = false;

                            // 添加一个小的容错值(比如5px)来处理可能的小数点误差
                            if (scrollableDiv.scrollTop + scrollableDiv.clientHeight + 5 >= scrollableDiv.scrollHeight) {
                                this.pageNum++;
                                this.getRelatedList();
                            }
                        };
                        scrollableDiv.addEventListener('scroll', this.scrollHandler);

                    }
                });
            } else {
                const scrollableDiv = document.getElementById('scrollable-div');
                if (scrollableDiv && this.scrollHandler) {
                    scrollableDiv.removeEventListener('scroll', this.scrollHandler);
                }
            }
        },
        'propertyData.content'(newVal, oldVal) {
            var length = this.propertyData.content.length;
            this.maxValueArr = [];
            this.minValueArr = [];
            for (var i = 0; i <= length; i++) {
                if (i == 0) {
                    let bx = {
                        value: 0,
                        label: '不限'
                    }
                    this.maxValueArr.push(bx)
                    this.minValueArr.push(bx)
                } else {
                    let other = {
                        value: i,
                        label: i
                    }
                    this.maxValueArr.push(other)
                    this.minValueArr.push(other)
                }
            }
        }
    },
    beforeDestroy() {
        const scrollableDiv = document.getElementById('scrollable-div');
        if (scrollableDiv && this.scrollHandler) {
            scrollableDiv.removeEventListener('scroll', this.scrollHandler);
        }
    },
    methods: {
        handlerBlurOnlyName() {
      console.log("88888");
      // var reg = /([\n])+/g
      // this.nameShowContent = this.nameShowContent.trim()
      let arr = this.nameShowContent.split(/[\s+,，；;]/g);
      arr = arr.filter((item) => item != "");
      this.people_num = arr.length;
      // this.people_num2 = arr.length
      this.onlyNameArr = arr;
    },
        demonstrate(n) {
            this.contentList = {
                title: "添加名单使用演示",
                imgurl:
                    "https://ossfastmake.mustke.com/12jielong/bdJL/add-mingdan-tishi.png",
            };
            this.demonVisible = true;
        },
        clockSwitchFn(e) {
            this.clockSwitch = e;
            this.activityDetail.clockSwitch = e;
        },
        ...mapActions("commonData", ["saveIsOpenShare"]),
        clockListNumFn(n) {
            this.clockListNumber = n;
            this.activityDetail.clockListNumber = n;
        },
        editFzNameList() {
            if (this.nameAddType == 1) {
                this.openNameListDrawerFun();
                this.nameAddOptionsShow = false;
            }
            if (this.nameAddType == 2) {
                // 更新中间值
                this.subsetCenterValueArr = JSON.parse(
                    JSON.stringify(this.subsetValueArr)
                );
                this.subsetCenterValueArr.forEach((item) => {
                    var reg = /([\n\r])+/g;
                    var str = item.clockInList.replace(reg, "\n");
                    let arr = str.split(/[\n+,，；;]/g);
                    arr = arr.filter((item) => item != "");
                    console.log(arr, "啥情况啊，这里怎么就不对呢");
                    item.clockInListNum = arr.length;
                });

                if (this.pickerName == "全部") {
                    this.subsetShow = true;
                } else {
                    // 根据pickerName的值，找到数组subsetCenterValueArr对应的值，深度赋值fzPopItemInfo
                    this.fzPopItemInfo = JSON.parse(
                        JSON.stringify(
                            this.subsetCenterValueArr.find(
                                (item) => item.listGroupName == this.pickerName
                            )
                        )
                    );
                    this.fzTitle = this.fzPopItemInfo.listGroupName;
                    this.fzValue = this.fzPopItemInfo.clockInList;
                    this.handlerBlur();
                    this.showModal = true;
                    this.copyTextAreaShow = true;
                    this.modelContentDel = true;
                    setTimeout(() => {
                        this.placeholderText1 =
                            "请输入姓名名单，每个名单可用中英文逗号,换行隔开，最大输入为100个名单。可复制粘贴";
                    }, 350);

                    this.handleSubShow = true;
                }
            }
        },
        foreverValidChange(e) {
            this.foreverValidChecked = e;
            if (e == true) {
                this.activityDetail.endTime = '2099-12-31 23:59:59';
            }
        },
        selectOptionClick(e) {
            console.log(e)
            this.formClock.clockSupplyType = e;
            if (e == 0) {
                this.supplyTxt = '总共'
            }
            if (e == 3) {
                this.supplyTxt = '每天'
            }
            if (e == 2) {
                this.supplyTxt = '每周'
            }
            if (e == 1) {
                this.supplyTxt = '每月'
            }
            this.disbandBox = true;
        },
        confirmModal() {
            if (this.clockSupplyCenterText === '') {
                this.$message('补卡次数不能为空');
                return false
            }
            this.formClock.supplyTimes = this.clockSupplyCenterText;
            this.clockSupplyText = this.formClock.supplyTimes;
            this.clockSupplyShow = true;
            this.disbandBox = false;
        },
        saveToDraft() {
            this.$confirm('是否保存为草稿?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.is_draft = 1;
                // 存为草稿
                this.submit()
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },
        confirmChangeForm() {
            // 走删除接口
            this.isDelOrder = 1;
            this.isDelSignInfoPop = false;
            // 编辑填表项接口
            this._updateSignList(this.signFieldClone, this.activityDetail.id)
        },
        // 保存分组/取消
        popupSaveFzFn(index) {
            if (index == 0) {
                this.subsetShow = false;
            }
            if (index == 1) {
                if (this.subsetCenterValueArr.length === 0) {
                    this.$message("分组不能为空");
                    return false;
                }
                let enter = true;
                for (let i = 0; i < this.subsetCenterValueArr.length; i++) {
                    if (this.subsetCenterValueArr[i].clockInList === "") {
                        this.$message(
                            this.subsetCenterValueArr[i].listGroupName + "分组名单不能为空"
                        );
                        enter = false;
                        break;
                    }
                }
                if (enter == false) {
                    return false;
                }
                this.nameAddType = 2;
                this.filteredArr = JSON.parse(
                    JSON.stringify(this.subsetCenterValueArr)
                );
                this.updateSignPeoplePicker();
                this.subsetShow = false;
            }
        },
        // 编辑/添加
        addOrEditFz(index) {
            if (index == 0) {
                this.placeholderText1 = "";
                this.handleSubShow = false;
                this.showModal = false;
                this.copyTextAreaShow = false;
                this.modelContentDel = false;
                this.fzValue = "";
            }
            if (index == 1) {
                if (this.fzTitle === "") {
                    this.$message("分组名称不能为空");
                    return false;
                }
                if (this.fzValue === "") {
                    this.$message("分组名单不能为空");
                    return false;
                }
                this.subsetCenterValueArr[this.commFzIndex].listGroupName =
                    this.fzTitle;
                this.subsetCenterValueArr[this.commFzIndex].clockInList = this.fzValue;

                this.subsetCenterValueArr.forEach((item) => {
                    var reg = /([\n\r])+/g;
                    var str = item.clockInList.replace(reg, "\n");
                    let arr = str.split(/[\n+,，；;]/g);
                    arr = arr.filter((item) => item != "");
                    console.log(arr, "啥情况啊，这里怎么就不对呢");
                    item.clockInListNum = arr.length;
                });

                this.handleSubShow = false;
                this.showModal = false;
                this.copyTextAreaShow = false;
                this.modelContentDel = false;
                this.fzValue = "";
                this.placeholderText1 = "";
                this.activityDetail.clockNameNumberSwitch = this.clockNameNumberSwitch;
            }
        },
        // 更新下拉选项 更新为全部
        updateSignPeoplePicker() {
            this.subsetValueArr = JSON.parse(
                JSON.stringify(this.subsetCenterValueArr)
            );
            this.pickerName = "全部";
            // 更新分组的下拉
            this.pickerNameSelectArr = [
                {
                    label: "全部",
                    value: 0,
                },
            ];
            var subArr = [];
            // 只将有数据的分组加入下拉列表
            this.subsetValueArr.forEach((item, subIndex) => {
                let clockInList = item.clockInList || "";
                clockInList = clockInList.trim();
                // 只添加有数据的分组
                if (clockInList !== "") {
                    subArr.push({
                        label: item.listGroupName || `分组${subIndex + 1}`,
                        value: subIndex + 1,
                    });
                }
            });
            const uniqueArr = [...new Set(subArr)];
            this.pickerNameSelectArr.push(...uniqueArr);

            // 更新全部名单
            let valueAll = "";
            this.subsetValueArr.forEach((son, i) => {
                valueAll += "," + son.clockInList;
            });
            // 处理一下 变成数组 可能需要做监听？
            var reg = /([\n\r])+/g;
            valueAll = valueAll.trim().replace(reg, "\n");
            let arr = valueAll.split(/[\n+,，；;]/g);
            arr = arr.filter((item) => item != "");
            this.nameListLength = arr.length; // 更新名单人数
            this.packetData = arr;
        },
        clockNameNumberSwitchChange(e) {
            this.clockNameNumberSwitch = e
            this.activityDetail.clockNameNumberSwitch = e;
        },
        downloadNameBox() {
            this.downListShow = true
            this.downloadBoxShow = true
            this.$refs.downloadBox.open()
        },
        // 清空
        emptyFn() {
            this.fzValue = '';
            this.fzNameArr = [];
        },
        // 预存名单
        prestore() {
            // uni.navigateTo({
            //     url: '/pages-mine/nameList/nameList'
            // })
        },

        // 选择分组
        selectGrouping(e) {
            const selectedItem = this.pickerNameSelectArr.find(item => item.value === e);
            this.pickerName = selectedItem ? selectedItem.label : '全部';
            this.pickerNameSelectShow = false;
            // 切换下面的数据
            // 筛选逻辑（示例：保留所有 listGroupName 存在的项）
            if (e != 0) {
                this.filteredArr = this.subsetValueArr.filter(item => {
                    return item.listGroupName === this.pickerName; // 精确匹配
                });
            } else {
                this.filteredArr = JSON.parse(JSON.stringify(this.subsetValueArr));
            }


            // 筛选packetData
            let valueAll = '';
            this.filteredArr.forEach((son, i) => {
                valueAll += ',' + son.clockInList;
            })
            // 处理一下 变成数组 可能需要做监听？
            var reg = /([\n\r])+/g
            valueAll = valueAll.trim().replace(reg, '\n')
            let arr = valueAll.split(/[\n+,，；;]/g);
            arr = arr.filter(item => item != "")
            this.packetData = arr;
        },





        // 减去
        subtractFzItem(index) {
            this.subsetCenterValueArr.splice(index, 1);
            // 重新调整分组名称，确保连续
            this.subsetCenterValueArr.forEach((item, idx) => {
                item.listGroupName = `分组${idx + 1}`;
            });
        },
        // 编辑
        editFzItem(index, item) {
            this.placeholderText1 = '';
            this.commFzInfo = item;
            this.commFzIndex = index;
            this.fzPopItemInfo = JSON.parse(JSON.stringify(item));
            // 处理数据
            this.handleSubShow = true;
            this.modelContentDel = true;
            this.fzTitle = this.fzPopItemInfo.listGroupName;

            this.fzValue = this.fzPopItemInfo.clockInList;
            this.handlerBlur()

            this.showModal = true;
            this.copyTextAreaShow = true;
            this.modelContentDel = true;

            setTimeout(() => {
                this.placeholderText1 = '请输入姓名名单，每个名单可用中英文逗号,换行隔开，最大输入为1000个名单。可复制粘贴'
            }, 350)

        },
        addFzItem() {
            const length = this.subsetCenterValueArr.length + 1;
            var obj = {
                clockInList: '',
                listGroupName: '分组' + length
            }
            this.subsetCenterValueArr.push(obj)
        },
        relayList() {
            this.nameAddOptionsShow = true;
        },
        nameAddChange() {
            // this.nameAddType = this.nameOrGroup;
            if (this.nameOrGroup == 0) {
                this.nameAddOptionsShow = false;
                this.clockSwitch = 1;
                this.activityDetail.clockSwitch = 1;
            }
            if (this.nameOrGroup == 1) {
                this.nameAddType = 1;
                this.clockSwitch = 2;
                this.activityDetail.clockSwitch = 2;
                this.openNameListDrawerFun();
                this.nameAddOptionsShow = false;
            }
            if (this.nameOrGroup == 2) {
                this.nameAddType = 2;
                this.clockSwitch = 2;
                this.activityDetail.clockSwitch = 2;
                // 更新中间值
                this.subsetCenterValueArr = JSON.parse(
                    JSON.stringify(this.subsetValueArr),
                );
                // 如果没有分组，创建两个分组：第一个有默认姓名，第二个为空
                if (this.subsetCenterValueArr.length === 0) {
                    this.subsetCenterValueArr = [
                        {
                            clockInList: "李某某,王某某",
                            listGroupName: "分组1",
                            clockInListNum: 2
                        },
                        {
                            clockInList: "",
                            listGroupName: "分组2",
                            clockInListNum: 0
                        }
                    ];
                } else {
                    // 确保至少有两个分组
                    if (this.subsetCenterValueArr.length < 2) {
                        // 如果只有一个分组，添加第二个空分组
                        if (this.subsetCenterValueArr.length === 1) {
                            // 如果第一个分组没有姓名，添加默认姓名
                            if (!this.subsetCenterValueArr[0].clockInList || this.subsetCenterValueArr[0].clockInList.trim() === "") {
                                this.subsetCenterValueArr[0].clockInList = "李某某,王某某";
                                this.subsetCenterValueArr[0].clockInListNum = 2;
                            }
                            // 添加第二个空分组
                            this.subsetCenterValueArr.push({
                                clockInList: "",
                                listGroupName: "分组2",
                                clockInListNum: 0
                            });
                        }
                    } else {
                        // 如果已有两个或更多分组，确保第一个分组有默认姓名（如果为空）
                        if (!this.subsetCenterValueArr[0].clockInList || this.subsetCenterValueArr[0].clockInList.trim() === "") {
                            this.subsetCenterValueArr[0].clockInList = "李某某,王某某";
                            this.subsetCenterValueArr[0].clockInListNum = 2;
                        }
                    }
                }

                this.subsetCenterValueArr.forEach((item) => {
                    var reg = /([\n\r])+/g;
                    var str = item.clockInList.replace(reg, "\n");
                    let arr = str.split(/[\n+,，；;]/g);
                    arr = arr.filter((item) => item != "");
                    item.clockInListNum = arr.length;
                    if (item.listGroupName == "") {
                        item.listGroupName = "分组" + (this.subsetCenterValueArr.indexOf(item) + 1);
                    }
                });

                // 不立即同步到 subsetValueArr，只在保存时才同步

                // 更新分组的下拉列表（根据subsetValueArr，因为这是实际保存的值）
                // 如果subsetValueArr为空，显示默认分组1
                this.pickerName = "全部";
                this.pickerNameSelectArr = [
                    {
                        label: "全部",
                        value: 0,
                    },
                ];
                var subArr = [];
                if (this.subsetValueArr && this.subsetValueArr.length > 0) {
                    // 只将有数据的分组加入下拉列表
                    this.subsetValueArr.forEach((item, subIndex) => {
                        let clockInList = item.clockInList || "";
                        clockInList = clockInList.trim();
                        // 只添加有数据的分组
                        if (clockInList !== "") {
                            subArr.push({
                                label: item.listGroupName || `分组${subIndex + 1}`,
                                value: subIndex + 1,
                            });
                        }
                    });
                }
                // 如果所有分组都没有数据，显示默认分组1
                if (subArr.length === 0) {
                    subArr.push({
                        label: "分组1",
                        value: 1,
                    });
                }
                const uniqueArr = [...new Set(subArr)];
                this.pickerNameSelectArr.push(...uniqueArr);
                this.pickerNameSelectArr.push(...uniqueArr);
				if (!this.packetData || this.packetData.length === 0) {
					// 从subsetCenterValueArr的第一个分组获取数据
					if (this.subsetCenterValueArr.length > 0 && this.subsetCenterValueArr[0].clockInList) {
						var reg = /([\n\r])+/g;
						let nameList = this.subsetCenterValueArr[0].clockInList;
						nameList = nameList.trim().replace(reg, "\n");
						let arr = nameList.split(/[\n+,，；;]/g);
						arr = arr.filter(item => item != "");
						this.packetData = arr;
						this.nameListLength = arr.length;
					} else {
						// 如果没有分组数据，设置默认值
						this.packetData = ["李某某", "王某某"];
						this.nameListLength = 2;
					}
				}

                this.subsetShow = true;
                this.nameAddOptionsShow = false;
            }
        },
        // 提示--上传图片
        uploadPromptImage(event) {
            this.selectedFile = event.target.files[0];
            var pettern = /^image/;
            if (!pettern.test(this.selectedFile.type)) {
                this.$message('文件格式不正确');
                return;
            }
            if (this.selectedFile.size / 1048576 > 5) {
                this.$message('图片大小小于5M');
            }
            const loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            var parm = {
                file: this.selectedFile,
                type: 'modularImg'
            }
            axios.post(serverConfig.baseURL + '/file/uploadFile', parm, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Token': localStorage.getItem("token")
                }
            })
                .then(response => {
                    loading.close();
                    var data = response.data
                    if (data.status == 1) {
                        this.propertyData.promptImage = data.msg;
                    } else {
                        this.$message(response.data.msg);
                    }
                })
                .catch(error => {
                    loading.close();
                });
        },
        //属性设置提交
        propertySet() {
            if (this.propertyData.type == 4) {
                if (this.propertyData.isRequired == 0) {
                    this.propertyData.minValue = 0
                }
                if (this.propertyData.isRequired == 1) {
                    if (this.propertyData.minValue == 0) {
                        this.propertyData.minValue = 1
                    }
                }
                // 如果是多选，最少不能大于最多
                if (this.propertyData.maxValue != 0 && this.propertyData.minValue > this.propertyData.maxValue) {
                    this.$message('最少可选不能大于最多可选');
                    return false;
                }
            }

            this.propertyData.isRequiredChecked == true ? this.propertyData.isRequired = 1 : this.propertyData.isRequired = 0
            this.propertyData.isOpenChecked == true ? this.propertyData.isOpen = 1 : this.propertyData.isOpen = 0
            this.listList[0].signField[this.commIndex] = { ...this.propertyData }
            this.propertySetShow = false;
        },
        imgNumCheckChange(e) {
            this.propertyData.imageUploadLimit = e;
        },
        // 文本格式-
        formatCheckChange(e) {
            this.propertyData.isFormatCheck = e;
        },
        // 属性设置-
        attributeSet(info, index) {
            this.commIndex = index;
            this.commType = info.type;
            info.currentIndex = index;
            this.propertyData = { ...info };
            this.commType = this.propertyData.type;
            this.tipsContent = this.propertyData.promptExplanation;
            this.propertySetShow = true;
        },


        openStudyPopup(type) {
            this.studyContent = '开启后，参与人可在地图中搜索定位，若需要显示参与人实时位置，请不要开启';
            this.$refs.studyBox.open()
        },
        closeStudyBox() {
            this.$refs.studyBox.close()
        },
        // 批量
        batchOptions() {
            this.lineCopywriting = '';
            this.placeholderContent = '';
            this.batchOptionShow = true;
        },
        closeBatch() {
            this.placeholderContent = '';
            this.$refs.batchAdd.close();
            this.lineCopywriting = '';
        },
        // 换行添加
        addLineBreak() {
            if (this.lineCopywriting == '') {
                this.$message('请添加选项');
                return false;
            }
            var ary = this.lineCopywriting.split('\n');
            if (ary.length > 15) {
                this.$message('一行一个选项，最大支持添加15个');
                return false;
            }
            for (var i = 0; i < ary.length; i++) {
                if (ary[i] != null && ary[i].trim() != "") {
                    var inp = {
                        value: ary[i]
                    }
                    this.propertyData.content.push(inp)
                }
            }
            this.lineCopywriting = '';
            this.placeholderContent = '';
            this.batchOptionShow = false;
        },
        // 添加选项
        addOption() {
            var obj = {
                value: '',
            }
            this.propertyData.content.push(obj)
        },
        //删除轮播图
        trash(index) {
            if (this.propertyData.content.length == 1) {
                this.$message('请至少保留一项');
                return false;
            }
            this.propertyData.content.splice(index, 1)
            if (Number(this.propertyData.maxValue) >= this.propertyData.content.length) {
                this.propertyData.maxValue = this.propertyData.content.length
            }
            if (Number(this.propertyData.minValue) >= this.propertyData.content.length) {
                this.propertyData.minValue = this.propertyData.content.length
            }
        },
        // 上移
        upTr(index) {
            if (index == 0) {
                this.$message('已经是第一项');
                return false;
            }
            //在上一项插入该项
            this.propertyData.content.splice(index - 1, 0, (this.propertyData.content[index]));
            //删除后一项
            this.propertyData.content.splice(index + 1, 1);
        },
        // 下移
        downTr(index) {
            if (index == this.propertyData.content.length - 1) {
                this.$message('已经是最后一项');
                return false;
            }
            //在下一项插入该项
            this.propertyData.content.splice(index + 2, 0, (this.propertyData.content[index]));
            // 删除前一项
            this.propertyData.content.splice(index, 1);
        },
        // 日期
        attributeTimeChange(type, index) {
            this.propertyData.timeSelectType = index;
        },
        // 地域
        attributeAreaChange(type, index) {
            this.propertyData.areaSelectType = index;
        },
        attributeDateChange(type, index) {
            this.propertyData.dateSelectType = index;
        },

        checkFun(n) {
            if (this.propertyData.type == 4) {
                if (this.propertyData.isRequired == 0) {
                    this.propertyData.minValue = 0
                }
                if (this.propertyData.isRequired == 1) {
                    this.propertyData.minValue = 1
                }
            }
        },

        addgljl(idx) {
            this.modulCommonIndex = idx;
            // 获取当前已关联的活动ID数组
            const associatedIds = this.modularList[this.modulCommonIndex].info.associationActivityId || [];

            // 遍历relatedList，设置checked状态
            this.relatedList = this.relatedList.map(item => {
                return {
                    ...item,
                    checked: associatedIds.some(associatedItem => associatedItem.id === item.id)
                };
            });

            this.relatedDrawerShow = true;
        },
        relateItemChange(e, info, index) {
            info.checked = e;
        },
        relatedAdd() {
            const newArray = [];
            this.relatedList.forEach(item => {
                if (item.checked === true) {
                    const newItem = {
                        id: item.id,
                        name: item.name,
                        activity_type: item.activity_type,
                        activity_big_type: item.activity_big_type,
                    };
                    newArray.push(newItem);
                }
            });
            this.modularList[this.modulCommonIndex].info.associationActivityId = newArray;
            this.relatedDrawerShow = false;
        },
        delRelatedFiles(fileIndex, fatherIndex) {
            this.modularList[fatherIndex].info.associationActivityId.splice(fileIndex, 1);
        },
        async getRelatedList() {
            if (this.isLoading) return; // 防止重复加载
            this.isLoading = true;
            const {
                data,
                msg,
                status
            } = await getCreateList({
                pageNum: this.pageNum,
                pageSize: 15,
                activityBigType: '',
                recordType: 1,
                isDraft: '',
                activityType: '',
                activeState: this.activeState,
                timeRange: '',
                startTime: '',
                endTime: '',
                sortType: 1,
                activityName: '',

            });
            if (this.pageNum == 1) {
                this.relatedList = [];
            }
            this.totalRow = data.total;
            this.pages = data.pages
            this.pageNum = data.pageNum
            data.list.forEach((item, index) => {
                item.checked = false;
            })

            // 过滤掉当前活动 ID 的数据
            const filteredList = data.list.filter(item => item.id.toString() !== this.activityId.toString());
            this.relatedList = this.relatedList.concat(filteredList);
            this.$forceUpdate()

        },

        relatedDrawerClose() {
            this.relatedDrawerShow = false;
        },
        subsetDrawerClose() {
            // 检查是否有有效数据（检查subsetValueArr，因为subsetCenterValueArr是中间值，可能被修改但未保存）
            let hasData = false;
            if (this.subsetValueArr && this.subsetValueArr.length > 0) {
                // 检查是否有分组包含非空的名单
                hasData = this.subsetValueArr.some(item => {
                    let clockInList = item.clockInList || "";
                    clockInList = clockInList.trim();
                    return clockInList !== "";
                });
            }

            // 如果没有数据，设置为默认分组1
            if (!hasData) {
                this.subsetValueArr = [
                    {
                        clockInList: "李某某,王某某",
                        listGroupName: "分组1",
                    }
                ];
                // 更新packetData和nameListLength
                var reg = /([\n\r])+/g;
                let nameList = "李某某,王某某";
                nameList = nameList.trim().replace(reg, "\n");
                let arr = nameList.split(/[\n+,，；;]/g);
                arr = arr.filter(item => item != "");
                this.packetData = arr;
                this.nameListLength = arr.length;
            }

            // 更新分组的下拉列表（只将有数据的分组加入下拉列表）
            this.pickerName = "全部";
            this.pickerNameSelectArr = [
                {
                    label: "全部",
                    value: 0,
                },
            ];
            var subArr = [];
            if (this.subsetValueArr && this.subsetValueArr.length > 0) {
                // 只将有数据的分组加入下拉列表
                this.subsetValueArr.forEach((item, subIndex) => {
                    let clockInList = item.clockInList || "";
                    clockInList = clockInList.trim();
                    // 只添加有数据的分组
                    if (clockInList !== "") {
                        subArr.push({
                            label: item.listGroupName || `分组${subIndex + 1}`,
                            value: subIndex + 1,
                        });
                    }
                });
            }
            // 如果所有分组都没有数据，显示默认分组1
            if (subArr.length === 0) {
                subArr.push({
                    label: "分组1",
                    value: 1,
                });
            }
            const uniqueArr = [...new Set(subArr)];
            this.pickerNameSelectArr.push(...uniqueArr);

            // 清空中间值
            this.subsetCenterValueArr = [];
            this.subsetShow = false;
        },
        handleSubDrawerClose() {
            this.handleSubShow = false;
        },

        propertyDrawerClose() {
            this.propertySetShow = false;
        },

        openMusic(info) {
            var link = info.fileUrl;
            this.musicLink = this.imageUrl + link;
            this.musicDialog = true;
        },

        submit() {
            if (this.isrepeatClick) {
                return
            }
            this.isrepeatClick = true
            let that = this;
            var isStop = false
            //校验是否填写了接龙标题
            if (this.activityDetail.name == '' || this.activityDetail.name == null) {
                this.$message('请填写通知标题');
                this.isrepeatClick = false
                return false
            }
            if (this.autographSwitch == 1 && (this.activityDetail.autograph == null || this.activityDetail.autograph == '')) {
                this.$message('请输入签名');
                this.isrepeatClick = false
                return
            }

            // 转格式
            that.modular1 = JSON.parse(JSON.stringify(this.modularList))
            that.modular1.map((item, index) => {
                if (this.is_draft == 0) {
                    if (isStop) {
                        this.isrepeatClick = false
                        return
                    }
                    if (item.type == 1 && item.info.value == "") {
                        isStop = true;
                        this.$message('请填写接龙标题');
                    } else if (item.type == 2 && item.info.value == "") {
                        isStop = true;
                        this.$message('请填写接龙内容');
                    } else if (item.type == 3 && item.info.imgarr.length == 0) {
                        isStop = true;
                        this.$message('请上传图片');
                    } else if (item.type == 9 && item.info.imgarr.length == 0) {
                        isStop = true;
                        this.$message('请上传大图模块图片');
                    } else if (item.type == 4 && (item.info.latitude == "" || item.info.longitude == "")) {
                        isStop = true;
                        this.$message('请选择地址');
                    } else if (item.type == 5 && item.info.fileUrl == "") {
                        isStop = true;
                        this.$message('请上传文件');
                    } else if (item.type == 6 && item.info.filesArr.length == 0) {
                        isStop = true;
                        this.$message('请上传音频');
                    } else if (item.type == 7 && item.info.fileUrl == "") {
                        isStop = true;
                        this.$message('请上传视频');
                    }
                    if (item.type == 8 && item.info.link == '') {
                        isStop = true;
                        this.$message('请填写公众号链接');
                    }
                    if (item.type == 8 && item.info.officialAccountTitle == '') {
                        isStop = true;
                        this.$message('请填写公众号文章标题');
                    }
                    if (item.type == 9 && (item.info.videoId == '' || item.info.videoNumberID == '')) {
                        isStop = true;
                        this.$message('请填写视频号信息');
                    }
                    if (item.type == 12 && (item.info.appid == '' || item.info.pagePath == '' || item.info.appTitle == '')) {
                        isStop = true;
                        this.$message('请填写其他小程序信息');
                    }
                    if (item.type == 11 && item.copy_region_conten == '') {
                        isStop = true;
                        this.$message('请填写一键复制区信息');
                    }
                }
                item.info = JSON.stringify(item.info)
            })
            if (this.selectType == "add") {
                this.activityDetail.templateId = this.activityDetail.id
                delete this.activityDetail.id
            }

            that.activityDetail.shareTitle = ''
            that.activityDetail.shareCotent = ''
            that.activityDetail.shareBtnWord = ''
            that.activityDetail.shareBack = ''
            that.activityDetail.shareLogo = ''
            that.activityDetail.shareImg = ''

            // 高级设置
            that.activityDetail.shareStatus = this.shareStatus;
            that.activityDetail.commentStatus = this.commentStatus;
            that.activityDetail.updateSignInfo = this.updateSignInfo;
            that.activityDetail.confirmWord = this.confirmWord
            that.activityDetail.copyStatus = this.copyStatus


            // 新加的 2024/8/1
            that.activityDetail.isanonymous = this.isanonymous;
            that.activityDetail.publisher = localStorage.getItem("jlnickname") //发布人姓名
            that.activityDetail.is_notice = this.is_notice; //接龙情况通知开关

            that.activityDetail.copywriting = this.copywriting//自定义文案
            that.activityDetail.copyimage = this.copyimage//自定义图片

            that.activityDetail.is_destination = this.is_destination;//指定接龙位置
            that.activityDetail.deliveryaddress = this.deliveryaddress;//指定接龙位置坐标

            that.activityDetail.submitcopy = this.isType == '109' || this.submitcopy ? this.submitcopy : '提交'//报名页面提交按钮文案
            that.activityDetail.registrationtime = this.registrationtime;//修改报名信息开始时间
            that.activityDetail.endregistrationtime = this.endregistrationtime;//修改报名信息结束时间
            that.activityDetail.custombutton = 1 //uni.getStorageSync('custombutton')//自定义按钮标题，总开关
            that.activityDetail.checkinrange = this.checkinrange; //打卡范围
            that.activityDetail.anonymousparticipation = this.anonymousparticipation; //匿名参与
            that.activityDetail.specifyaddress = this.specifyaddress;

            that.activityDetail.deleteregistration = this.deleteregistration; //修改报名信息
            that.activityDetail.startdeletingtime = this.startdeletingtime; //删除报名信息开始时间
            that.activityDetail.enddeletingtime = this.enddeletingtime; //修改报名信息结束时间

            that.activityDetail.is_forward = this.is_forward;
            that.activityDetail.thumbs_up = this.thumbs_up;
            that.activityDetail.is_comment = this.is_comment;
            that.activityDetail.is_score = this.is_score;
            that.activityDetail.musicId = ''
            that.activityDetail.musicName = '';

            that.submitFn()

        },
        async submitFn() {
            console.log("去创建")
            let appliction = []; //报名填表项
            let fmClockIn = {};
            let clockInList;
            let projectDelIds;

            clockInList = this.subsetValueArr;
            this.activityDetail.coverImg = this.baseurl;
            this.activityDetail.createSource = 2; //创建来源 1:小程序 2:pc

            let signFieldClone = ''
            signFieldClone = JSON.parse(JSON.stringify(this.listList))
            signFieldClone[this.indexIdx].signField.push(...this.delListInfo);
            signFieldClone.map((item, index) => {
                item.signField.map(itm => {
                    if (itm.content != '' && itm.content != null) {
                        return itm.content = JSON.stringify(itm.content)
                    } else {
                        return {}
                    }
                })

            })
            this.signFieldClone = signFieldClone;
            this.loadingShow = this.$loading({
                lock: true,
                text: '保存中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.activityDetail.activityType = this.isType;
            // 创建/编辑活动
            updateActivity({
                ...this.activityDetail,
                "modular": this.modular1,
                "modularDelIds": this.modularDelIds,
                "activityBigType": '2', //接龙大类型 接龙1 通知2
                "activityType": this.isType,
                "groupId": this.groupId,
                "clockInList": clockInList, //预存名单列表
                "isInFolder": this.folderId ? 2 : (this.isInFolder || 1),
                "folderId": this.folderId ? this.folderId : "",

            }).then((res) => {
                console.log(res, "res");
                if (res.status == 1) {
                    // 调用辅助接口updateActivitySignList
                    if (this.selectType == "add") {
                        try {
                            updateActivitySignList({
                                id: res.data,
                                signList: signFieldClone,
                            });
                        } catch (error) {
                            console.error('调用updateActivitySignList失败:', error);
                        }
                         // todo 去创建成功页 触发commonData.js页中的saveIsOpenShare方法，改变isOpenShare的值为true
                            this.saveIsOpenShare(true);
                    }
                    this.loadingShow.close();
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });

                    // 如果在文件夹中创建的，返回文件夹页面
                    if (this.folderId) {
                        router.replace({
                            path: "/folderDetails",
                            query: { folderId: this.folderId },
                        });
                    } else {
                        router.replace("/releaseNotes");
                    }
                } else {
                    this.$message(res.msg);
                    this.isrepeatClick = false;
                }
            })
        },
        // 判断填表项状态
        async _isUpdateSignList(signList, id) {
            let result = await isUpdateSignList({
                signList: signList,
                id: this.activityDetail.id,
                userId: this.activityDetail.userId
            })
            if (result.status == 1) {
                this.loadingShow.close();
                this.isrepeatClick = false
                this.isDelSignInfoPop = true;
            }
            if (result.status == 2) {
                // 去保存和删除
                this.isDelOrder = '';
                this._updateSignList(signList, id)
            }
        },
        // 编辑填表项
        async _updateSignList(signList, id) {
            let result = await updateSignList({
                signList: signList,
                id: this.activityId,
                userId: this.activityDetail.userId
            })
            if (result.status == 1) {
                this.loadingShow.close();
                this.$message({
                    message: '保存成功',
                    type: 'success'
                });
                // 如果是草稿 跳到index
                if (this.is_draft == 1) {
                    router.push("/home");
                    return false;
                }
                // 如果在文件夹中创建的，返回文件夹页面
                if (this.folderId) {
                    router.replace({
                        path: "/folderDetails",
                        query: { folderId: this.folderId },
                    });
                } else {
                    router.replace("/releaseNotes");
                }
            } else {
                this.loadingShow.close();
                this.$message(result.msg);
                this.isrepeatClick = false
            }
        },
        // 活动详情
        activityDetailFun() {
            var that = this;
            activityDetail({
                activityKey: this.activityKey,
                selectType: this.selectType,
            }).then(res => {
                if(res.status ==403){
                    this.$message({
                    message:res.msg,
                    type: "warning",
                    duration:2000,
                    });
                    setTimeout(() => {
                        router.replace('/home')
                    }, 2000);
                }
                this.activityDetail = res.data.activityDetail;
                this.activityId = this.activityDetail.id
                this.activityDetail.activityId = this.activityId;
                // this.activityDetail.id = this.activityId;


                if (res.data.activityDetail.beginTime) {
                    this.actStartAndEndTime = [res.data.activityDetail.beginTime, res.data.activityDetail.endTime]
                }
                if (this.selectType == 'add') {
                    this.autographSwitch = 2;
                    var startTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
                    var endTime ="2099-12-31 23:59:59" // 默认设置为永久有效
                    this.activityDetail.beginTime = startTime;
                    this.activityDetail.endTime = endTime;
                    this.actStartAndEndTime = [startTime, endTime]
                } else {
                    this.autographSwitch = this.activityDetail.autographSwitch;
                }
                if (this.activityDetail.autographSwitch == 1) {
                    this.autographSwitch = 2
                }
                if (this.activityDetail.autographSwitch == 2) {
                    this.autographSwitch = 1
                }
                if (this.activityDetail.endTime == '2099-12-31 23:59:59') {
                    this.foreverValidChecked = true;
                }

                res.data.modular.map((item) => {
                    if (item.type == 4) {
                        var obj = {
                            lng: 116.403963,
                            lat: 39.915119
                        }
                        item.location = obj;
                    }
                    item.info = item.info.replace(/\n/g, "\\n")
                    item.info = item.info.replace(/↵/g, " ")
                    var info = JSON.parse(item.info)
                    if (that.selectType == "add") {
                        delete item.id
                        delete item.activityId
                    }
                    item.info = info
                })
                this.modularList = res.data.modular;

                if (res.data.modular.length <= 1) {
                    var textarea = document.querySelector('.el-textarea__inner');
                    textarea.addEventListener('input', (e) => {
                        textarea.style.height = '100px';
                        textarea.style.height = e.target.scrollHeight + 'px';
                    });
                }

                // 填表项
                let signFieldCloneS = ''
                signFieldCloneS = JSON.parse(JSON.stringify(res.data.signList))
                signFieldCloneS.map((itm) => {
                    itm.signField.map((item) => {
                        item.isUniqueCheckChecked = item.isUniqueCheck == 1 ? true : false;
                        item.isRequiredChecked = item.isRequired == 1 ? true : false;
                        item.isOpenChecked = item.isOpen == 1 ? true : false;
                        if (item.content != '' && item.content != null) {
                            return item.content = JSON.parse(item.content)
                        } else {
                            item['num'] = 3;
                            return {}
                        }
                    })
                })
                this.$nextTick(() => {
                    this.listList = signFieldCloneS
                })
                // 接龙名单
                if (res.data.clockNameList && res.data.clockNameList.length) {
                    // res.data.clockNameList.forEach(item => {
                    //     if (res.data.activityDetail.isTemplate == 1) {
                    //         this.packetData.push(item.clockName)
                    //     } else {
                    //         this.packetData.push(item.clockName)
                    //         this.packetData.map((res, index) => {
                    //             if (res == "") {
                    //                 this.packetData.splice(index, 1)
                    //             }
                    //         })
                    //     }
                    // })

                    var nameStr = "";
                    res.data.clockNameList.forEach((item) => {
                        nameStr += item.clockName + ",";
                        this.packetData = nameStr.split(",");
                        this.packetData.map((res, index) => {
                            if (res == "") {
                                this.packetData.splice(index, 1);
                            }
                        });
                    });
                    this.subsetValueArr = res.data.clockNameList.map((item) => {
                        return {
                            clockInList: item.clockName,
                            listGroupName: item.listGroupName ? item.listGroupName : "",
                        };
                    });
                    // 使用 reduce 按 listGroupName 分组合并
                    const mergedArr = Object.entries(
                        this.subsetValueArr.reduce((acc, cur) => {
                            const key = cur.listGroupName;
                            if (!acc[key]) {
                                acc[key] = [];
                            }
                            acc[key].push(cur.clockInList);
                            return acc;
                        }, {})
                    ).map(([groupName, clockInLists]) => ({
                        listGroupName: groupName,
                        clockInList: clockInLists.join(","),
                    }));

                    console.log(mergedArr, "mergedArrwhat?");
                    this.subsetValueArr = mergedArr;

                    // 名单人数
                    this.nameListLength = this.packetData.length;
                    this.pickerName = "全部";
                    // 更新分组的下拉
                    // 更新分组的下拉
                    this.pickerNameSelectArr = [
                        {
                            label: "全部",
                            value: 0,
                        },
                    ];
                    var subArr = [];
                    this.subsetValueArr.forEach((item, subIndex) => {
                        subArr.push({
                            label: item.listGroupName,
                            value: subIndex + 1,
                        });
                    });
                    const uniqueArr = [...new Set(subArr)];
                    this.pickerNameSelectArr.push(...uniqueArr);

                    // 判断是不是分组
                    // 检查合并后的数组，如果有多个分组，或者分组名称有实际值（非空字符串），则是分组模式
                    // 如果创建时是"仅添加名单"，所有项的listGroupName都是空字符串，合并后只有一个分组
                    // 如果创建时是"添加分组+名单"，会有多个分组，或者分组名称有实际值
                    const hasMultipleGroups = this.subsetValueArr.length > 1;
                    const hasGroupName = this.subsetValueArr.some(item => {
                        const groupName = item.listGroupName;
                        return groupName && groupName !== "" && groupName.trim() !== "";
                    });

                    if (hasMultipleGroups || hasGroupName) {
                        this.nameAddType = 2;
                    } else {
                        this.nameAddType = 1;
                    }
                    console.log(this.nameAddType, "是不是分组啊--- 2是1不是");

                    this.subsetCenterValueArr = JSON.parse(
                        JSON.stringify(this.subsetValueArr)
                    );
                    this.subsetCenterValueArr.forEach((item) => {
                        var reg = /([\n\r])+/g;
                        var str = item.clockInList.replace(reg, "\n");
                        let arr = str.split(/[\n+,，；;]/g);
                        arr = arr.filter((item) => item != "");
                        console.log(arr, "啥情况啊，这里怎么就不对呢");
                        item.clockInListNum = arr.length;
                    });
                }

                // 打卡接龙
                if (res.data.clockInfo) {
                    this.formClock = res.data.clockInfo;
                    this.selectData = res.data.clockInfo.clockFrequencyName;
                    this.clockFrequencyName = res.data.clockInfo.clockFrequencyName;
                    //自定义周几赋值
                    res.data.clockInfo.clockFrequency.split(',').forEach(item => {
                        this.candidates.forEach(e => {
                            if (e.value == item) {
                                e.checked = 'true';
                                this.candidateList.push(e.value)
                            }
                        })
                    })
                    // 打卡地点
                    if (res.data.clockInfo.clockLocationInfo != "") {
                        this.formClock.address = JSON.parse(res.data.clockInfo.clockLocationInfo).address
                        this.formClock.clockRange = res.data.clockInfo.clockRange;
                    }
                    this.selectFrequency = res.data.clockInfo.clockFrequencyType;
                    this.formClock.clockFrequencyType = res.data.clockInfo.clockFrequencyType;

                    // 处理时间段
                    if (res.data.clockInfo.clockInTimeSlot && res.data.clockInfo.clockInTimeSlot.length) {
                        res.data.clockInfo.clockInTimeSlot.forEach((item, index) => {
                            item.ifDel = 2;
                            // item.startAndEnd = [item.startTime.toString(),item.endTime.toString()]
                            let a = [item.startTime.toString(), item.endTime.toString()]
                            this.$set(item, 'startAndEnd', a);
                        })
                        this.formClock.clockInTimeSlot = res.data.clockInfo.clockInTimeSlot;

                        if (res.data.clockInfo.clockInTimeSlot.length > 1) {
                            this.formClock.multiPeriodSwitch = 1;
                        }

                    }
                    this.$forceUpdate()

                    // 日期选择
                    this.formClock.customDate = res.data.clockInfo.customDate;
                    this.customDateArr = res.data.clockInfo.customDate.split(',');
                    // 截止日期
                    this.formClock.dayOfDate = res.data.clockInfo.dayOfDate;
                    this.formClock.timeOfDay = res.data.clockInfo.timeOfDay;
                    if (this.selectFrequency == 1) {
                        this.monthDay = res.data.clockInfo.dayOfDate;
                    }
                    if (this.formClock.timeOfDay) {
                        var str1 = this.formClock.timeOfDay.substring(0, 2)
                        this.endMonthArr2.forEach((item, index) => {
                            if (item.value == str1) {
                                this.monthHour = index
                            }
                        })
                    }
                    if (this.formClock.timeOfDay) {
                        var str2 = this.formClock.timeOfDay.substring(3)
                        this.endMonthArr3.forEach((item, index) => {
                            if (item.value == str2) {
                                this.monthMinute = index
                            }
                        })
                    }

                    this.formClock.clockFrequency = res.data.clockInfo.clockFrequency;
                    this.formClock.checkboxValue1 = res.data.clockInfo.clockFrequency.split(',')

                    // 打卡最大次数
                    if (res.data.clockInfo.clockFrequencyType == 1 || res.data.clockInfo.clockFrequencyType == 2) {
                        this.formClock.clockMaxNum = res.data.clockInfo.clockMaxNum;
                        if (res.data.clockInfo.clockMaxNum > 1) {
                            this.formClock.clockMaxSwitch = 1;
                        } else {
                            this.formClock.clockMaxSwitch = 2;
                        }
                        this.$forceUpdate()
                    }
                    this.interdict_people_num = res.data.activityDetail.interdict_people_num;
                    this.is_draft = res.data.activityDetail.is_draft;

                }

                // 高级设置
                var detailInfo = res.data.activityDetail;
                this.thumbs_up = detailInfo.thumbs_up;
                this.clockSwitch = detailInfo.clockSwitch.toString();
                this.activityDetail.clockSwitch = detailInfo.clockSwitch;
                // 根据clockSwitch和nameAddType设置nameOrGroup
                if (this.clockSwitch == 1 || this.clockSwitch == "1") {
                    this.nameOrGroup = 0; // 不启用
                } else if (this.clockSwitch == 2 || this.clockSwitch == "2") {
                    if (this.nameAddType == 1) {
                        this.nameOrGroup = 1; // 仅添加名单
                    } else if (this.nameAddType == 2) {
                        this.nameOrGroup = 2; // 添加分组+名单
                    }
                }


                // 根据clockSwitch和nameAddType设置nameOrGroup
                this.clockPresetsList()
            })


        },
        // 获取封面图片接口
        async coverimgClone() {
            const {
                data,
                msg,
                status
            } = await getCoverimgTemplate()
            this.imgInfo = data
            this.baseurl = this.baseurl ? this.baseurl : data[0].coverImg
            this.imgInfo.map((item, index) => {
                item.imgShowLv = false
            })
            this.imgInfo[0].imgShowLv = true;
            if (this.activityId != 2) {
                this.baseurl = this.activityDetail.coverImg
            } else {
                this.baseurl ? this.baseurl : this.imgInfo[0].path
            }
        },
        // 获取报名人数
        async _getSignList() {
            const {
                data,
                msg,
                status
            } = await getSignList({
                "activityId": this.activityDetail.id,
                "signShowType": this.activityDetail.signShowType,
            })

            if (status == 1) {
                if (data.pageInfo.list && data.pageInfo.list.length > 0) {
                    this.commonDisabled = true;
                } else {
                    console.log(data, '无人报名吗')
                }
            }
        },
        // 判断身份
        async _getProjectManageAdmin() {
            let result = await getProjectManageAdmin({
                activityId: this.activityId
            })
            if (result.status != 901) {
                this.isOtherPeople = result.data;
                if (this.activityId == 2) {
                    this.isOtherPeople = 1;
                }
            }

        },

        // 编辑名单
        nameLists(id) {
            this.nameId = id;
            this.clockPresetsDetail()
        },
        async clockPresetsDetail() {
            const {
                data,
                status
            } = await clockPresetsDetail({
                "id": this.nameId
            })
            if (status == 1) {
                this.clockShowPresetTitle = data.clockPresetTitle
                this.clockShowPresetContent = data.clockPresetContent
                this.handlerBlur()
                this.addNameListDrawer = true;
            }
        },
        FocusInterdictPeople() {
            if (this.interdict_people_num == 0) {
                this.interdict_people_num = ''
            }
        },
        BlurInterdictPeople(e) {
            if (this.interdict_people_num == 0 || this.interdict_people_num == '') {
                this.interdict_people_num = 0
            }

        },
        oninputFun(e) {
            // 正则表达式，匹配正整数和0
            const regex = /^(?:0|[1-9]\d*)$/;
            // 判断输入值是否匹配正则表达式
            if (!regex.test(e)) {
                // 如果不匹配，则将输入值重置为上一个合法的值
                e = e.replace(regex, '');
            }
        },
        cannotEdit() {
            this.$message({
                message: '当前活动已经有人报名，不能修改',
                type: 'warning'
            });
        },
        handlerBlur() {
            // var reg = /([\n\r])+/g
            // this.clockShowPresetContent = this.clockShowPresetContent.trim()
            let arr = this.clockShowPresetContent.split(/[\n\s+,，；;]/g);
            arr = arr.filter((item) => item != "");
            // this.people_num = arr.length
            this.people_num2 = arr.length;
        },
        handlerBlurFz() {
      // var reg = /([\n\r])+/g
      // this.fzValue = this.fzValue.trim()
      let arr = this.fzValue.split(/[\n\s+,，；;]/g);
      arr = arr.filter((item) => item != "");
      this.people_num2 = arr.length;
      this.onlyGroupArr = arr;
    },

        presetsDel(id) {
            this.nameId = id;
            this.$confirm('是否确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.confirmDelete();

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        EchoList(info) {
            if (this.openNameListDrawer == true) {
                this.nameShowContent = info.clockPresetContent;
                this.handlerBlurOnlyName();
            }
            if (this.handleSubShow == true) {
                this.fzValue = info.clockPresetContent;
                this.handlerBlurFz();
            }
            this.nameListDrawer = false;
        },
        // 删除名单
        async confirmDelete() {
            const {
                msg,
                status
            } = await clockPresetsDel({
                "id": this.nameId
            })
            if (status == 1) {
                this.$message({
                    type: 'success',
                    message: msg
                });
                this.clockPresetsList()
            } else {
                this.$message(msg);
            }
        },
        // 获取名单管理列表
        clockPresetsList() {
            clockPresetsList({
                pageNum: 1,
                pageSize: 10
            }).then(res => {
                this.presetsList = res.data.list
            })

        },

        // -添加模块
        addModule(num) {
            // 自定义内容1
            if (num == 0) {
                let kk = {
                    "type": 1,
                    "isCloneTf": 1,
                    info: {
                        "value": "",
                        "title": ""
                    }
                }
                this.modularList.push(kk)
            }
            // 小图
            if (num == 2) {
                var bb = {
                    "type": 3,
                    "isCloneTf": 1,
                    info: {
                        "value": "图片",
                        "imgarr": []
                    }
                }
                this.modularList.push(bb)
            }
            // 位置
            if (num == 3) {
                var cc = {
                    "type": 4,
                    "isCloneTf": 1,
                    info: {
                        "value": "地址",
                        "name": "",
                        "address": "",
                        "latitude": "",
                        "longitude": ""
                    },
                    location: {
                        lng: 116.403963,
                        lat: 39.915119
                    }
                }
                this.modularList.push(cc)
            }
            // 文件
            if (num == 4) {
                var dd = {
                    "type": 5,
                    "isCloneTf": 1,
                    info: {
                        "value": "文件",
                        filesArr: []
                    }
                }
                this.modularList.push(dd)
            }
            // 音频
            if (num == 5) {
                var ee = {
                    "type": 6,
                    "isCloneTf": 1,
                    info: {
                        "value": "音频",
                        "name": "",
                        "size": "",
                        "lastName": "",
                        "fileUrl": "",
                        filesArr: []
                    }
                }
                this.modularList.push(ee)
            }
            // 视频
            if (num == 6) {
                var ff = {
                    "type": 7,
                    "isCloneTf": 1,
                    info: {
                        "value": "视频",
                        "name": "",
                        "size": "",
                        "lastName": "",
                        "fileUrl": ""
                    }
                }
                this.modularList.push(ff)
            }
            // 大图
            if (num == 7) {
                var gg = {
                    "type": 9,
                    "isCloneTf": 1,
                    info: {
                        "value": "大图",
                        imgarr: []
                    }
                }
                this.modularList.push(gg)
            }
            // 一键复制
            if (num == 11) {
                var ggg = {
                    "type": 13,
                    "isCloneTf": 1,
                    info: {
                        "value": "一键复制区",
                        "copy_region_conten": '',
                    }
                }
                this.modularList.push(ggg)
            }
            // 公众号
            if (num == 8) {
                var gzh = {
                    "type": 10,
                    "isCloneTf": 1,
                    randomDecimal: Date.now(),
                    info: {
                        "value": "公众号标题",
                        "link": '',
                        "officialAccountTitle": ''
                    }
                }
                this.modularList.push(gzh)
            }
            // 视频号
            if (num == 9) {
                var sph = {
                    "type": 11,
                    "isCloneTf": 1,
                    randomDecimal: Date.now(),
                    info: {
                        "value": "视频号标题",
                        "videoId": '',
                        "videoNumberID": '',
                        "videoNumberTitle": ''
                    }
                }
                this.modularList.push(sph)
            }

            // 其他小程序
            if (num == 10) {
                var qtxcx = {
                    "type": 12,
                    "isCloneTf": 1,
                    randomDecimal: Date.now(),
                    info: {
                        "value": "其他小程序标题",
                        "appid": '',
                        "pagePath": '',
                        "appTitle": '',
                    }
                }
                this.modularList.push(qtxcx)
            }
            // 关联接龙
            if (num == 12) {
                var gljl = {
                    "type": 14,
                    "isCloneTf": 1,
                    randomDecimal: Date.now(),
                    info: {
                        "value": "关联接龙",
                        "associationActivityId": [],
                    }
                }
                this.modularList.push(gljl)
            }

            this.$forceUpdate()
        },

        // 添加表单项 姓名/手机号 等
        addForm(item, index) {
            if (item == 0) {
                var aa = {
                    "type": 1,
                    "fieldName": "姓名",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    "num": 3,
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    isRequiredChecked: true,
                    isOpenChecked: true,
                    isUniqueCheckChecked: false,
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「姓名」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(aa)
                this.$forceUpdate()
            } else if (item == 1) {
                var cc = {
                    "type": 11,
                    "fieldName": "手机号",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「手机号」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(cc)
                this.$forceUpdate()
            } else if (item == 2) {
                var dd = {
                    "type": 13,
                    "fieldName": "数量",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「数量」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(dd)
                this.$forceUpdate()
            } else if (item == 3) {
                var ee = {
                    "type": 3,
                    "fieldName": "日期",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「日期」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(ee)
                this.$forceUpdate()
            } else if (item == 4) {
                var ff = {
                    "type": 5,
                    "fieldName": "请上传图片",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「图片」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(ff)
                this.$forceUpdate()
            } else if (item == 5) {
                var gg = {
                    "type": 10,
                    "fieldName": "身份证",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「身份证」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(gg)
                this.$forceUpdate()
            } else if (item == 6) {
                var hh = {
                    "type": 15,
                    "fieldName": "时间",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「时间」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(hh)
                this.$forceUpdate()
            } else if (item == 7) {
                var qq = {
                    "type": 12,
                    "fieldName": "你所在的位置",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「位置」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(qq)
                this.$forceUpdate()
            } else if (item == 8) {
                var ww = {
                    "type": 8,
                    "fieldName": "请选择省市区",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「省市区」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(ww)
                this.$forceUpdate()
            } else if (item == 9) {
                var rr = {
                    "type": 2,
                    "fieldName": "性别",
                    "isRequired": 1,
                    "isOpen": 1,
                    "num": 2,
                    "content": [
                        {
                            value: "男",
                        },
                        {
                            value: '女'
                        }
                    ],
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「性别」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(rr)
                this.$forceUpdate()
            } else if (item == 10) {
                var tt = {
                    "type": 14,
                    "fieldName": "请上传健康码",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    "num": 7,
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启

                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「健康码」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(tt)
                this.$forceUpdate()
            } else if (item == 11) {
                var yy = {
                    "type": 14,
                    "fieldName": "请上传行程码",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    "num": 8,
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.listList[this.indexIdx].signField.push(yy)
                this.$forceUpdate()
            } else if (item == 12) {
                var uu = {
                    "type": 7,
                    "fieldName": "请填写录音标题",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「音频」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(uu)
                this.$forceUpdate()
            } else if (item == 13) {
                var sp = {
                    "type": 6,
                    "fieldName": "请填写视频标题",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「视频」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(sp)
                this.$forceUpdate()
            } else if (item == 14) {
                var yxx = {
                    "type": 19, // bdbdbd 新版本加入的
                    "fieldName": "邮箱",
                    "placeholder": "邮箱",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「邮箱」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(yxx)
                this.$forceUpdate()
            } else if (item == 15) {
                var xx = {
                    "type": 21, // bdbdbd 新版本加入的
                    "fieldName": "学校",
                    "placeholder": "学校",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「学校」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(xx)
                this.$forceUpdate()
            } else if (item == 16) {
                var yx = {
                    "type": 22, // bdbdbd 新版本加入的
                    "fieldName": "院系",
                    "placeholder": "院系",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「院系」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(yx)
                this.$forceUpdate()
            } else if (item == 17) {
                var gh = {
                    "type": 23, // bdbdbd 新版本加入的
                    "fieldName": "工号",
                    "placeholder": "工号",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「工号」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(gh)
                this.$forceUpdate()
            } else if (item == 18) {
                var xh = {
                    "type": 24, // bdbdbd 新版本加入的
                    "fieldName": "学号",
                    "placeholder": "学号",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「学号」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(xh)
                this.$forceUpdate()
            } else if (item == 19) {
                var gs = {
                    "type": 25, // bdbdbd 新版本加入的
                    "fieldName": "公司",
                    "placeholder": "公司",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「公司」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(gs)
                this.$forceUpdate()
            } else if (item == 20) {
                var zw = {
                    "type": 26, // bdbdbd 新版本加入的
                    "fieldName": "职位",
                    "placeholder": "职位",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「职位」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(zw)
                this.$forceUpdate()
            } else if (item == 21) {
                var bm = {
                    "type": 27, // bdbdbd 新版本加入的
                    "fieldName": "部门",
                    "placeholder": "部门",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「部门」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(bm)
                this.$forceUpdate()
            } else if (item == 22) {
                var dw = {
                    "type": 28, // bdbdbd 新版本加入的
                    "fieldName": "单位",
                    "placeholder": "单位",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「单位」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(dw)
                this.$forceUpdate()
            }

            if (item == 25) {
                var wj = {
                    "type": 32,
                    "fieldName": "文件",
                    "placeholder": "文件",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    "value": "",
                    watermarkImageUrl: '',
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「文件」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(wj)
                this.$forceUpdate()
            }

            // 水印拍照
            if (item == 23) {
                var sy = {
                    "type": 20, // bdbdbd 新版本加入的
                    "fieldName": "水印拍照",
                    "placeholder": "水印拍照",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    watermarkImageUrl: '',
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「水印」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(sy)
                this.$forceUpdate()
            }
            if (item == 24) {
                var qm = {
                    "type": 29,
                    "fieldName": "签名",
                    "placeholder": "签名",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    "value": "",
                    watermarkImageUrl: '',
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启

                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「签名」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(qm)
                this.$forceUpdate()
            }
            // 时间区间
            if (item == 31) {
                var qj = {
                    "type": 31,
                    "fieldName": "时间区间",
                    "placeholder": "时间区间",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    "value": "",
                    watermarkImageUrl: '',
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「时间区间」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(qj)
                this.$forceUpdate()
            }
            // 单行文本
            if (item == -1) {
                var pp = {
                    "type": 1,
                    "fieldName": "",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    "num": 4, // 单行文本
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「单行文本」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(pp)
                this.$forceUpdate()
            }
            // 单选
            if (item == -2) {
                let pp = {
                    "type": 2,
                    "fieldName": "单选",
                    "isRequired": 1,
                    "isOpen": 1,
                    "num": 1,
                    "content": [{
                        value: '',
                        randomDecimal: Date.now()
                    }],
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「单选」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(pp)
                this.$forceUpdate()
            }
            // 多选
            if (item == -3) {
                var ll = {
                    "type": 4,
                    "fieldName": "多选",
                    "isRequired": 1,
                    "isOpen": 1,
                    "isChoose": 2,
                    "isChooseNum": 0,
                    "content": [{
                        value: '',
                        randomDecimal: Date.now()
                    }],
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「多选」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(ll)
                this.$forceUpdate()
            }
            // 多行文本
            if (item == -4) {
                var hh2 = {
                    "type": 9,
                    "fieldName": "",
                    "isRequired": 1,
                    "isOpen": 1,
                    "content": "",
                    isUniqueCheck: 0, //是否唯一校验 0=否 1=是
                    isFormatCheck: 0,
                    randomDecimal: Date.now(),
                    promptSwitch: 2, //  '开启提示默认 2 关 1 开'
                    promptImage: '', // 提示图片
                    promptExplanation: '', // 提示说明
                    displayStyle: 1, // 默认1列表式 2 下拉式';
                    maxValue: 0, // 最大可选
                    minValue: 1, // 最小可选
                    positionSwitch: 1, // 指定位置开关 默认1关闭 2开启
                }
                this.$message({
                    showClose: true,
                    message: '已经添加了「多行文本」',
                    type: 'success'
                });
                this.listList[this.indexIdx].signField.push(hh2)
                this.$forceUpdate()
            }
        },

        // 打开预存名单列表
        openNamelistFun() {
            this.nameListDrawer = true;
        },
        // 添加接龙名单
        sureAddNameList() {
            var reg = /([\n\r])+/g
            this.nameShowContent = this.nameShowContent.trim().replace(reg, '\n')
            let arr = this.nameShowContent.split(/[\n\s+,，；;]/g);
            arr = arr.filter(item => item != "")

            if (arr.length > 1000) {
                this.$message('名单人数不能超过1000');
                return
            }
            this.packetData = arr;
            this.nameListLength = arr.length;
            this.openNameListDrawer = false;
            this.subsetValueArr = [{
                clockInList: this.packetData.join(),
                listGroupName: '',
            }]
            this.nameAddType = 1;
            // 清值
            this.subsetCenterValueArr = [];
            this.pickerName = '全部';
        },
        importFiles(event) {
            var that = this;
            this.selectedFile = event.target.files[0];
            let lastArr = this.selectedFile.name.split('.')
            if (lastArr[1] != "xls" && lastArr[1] != "xlsx") {
                this.$message('文件格式不正确');
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            var parm = {
                file: this.selectedFile,
                type: 'modularFile'
            }
            axios.post(serverConfig.baseURL + '/file/uploadFileExcel', parm, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Token': localStorage.getItem("token")
                }
            })
                .then(response => {
                    loading.close();
                    var data = response.data
                    if (data.status == 1) {
                        that.clockShowPresetContent = data.data;
                    } else {
                        this.$message(response.data.msg);
                    }
                })
                .catch(error => {
                    loading.close();
                    console.log('上传error', error);
                });
        },
        toAddRoster() {
            this.nameId = '';
            this.clockShowPresetTitle = '';
            this.clockShowPresetContent = '';
            this.addNameListDrawer = true;
        },
        // 添加预存名单列表
        async clockPresetsAdd() {
            let arr = this.clockShowPresetContent.split(/[\n\s+,，；;]/g);
            if (arr.length > 1000) {
                this.$message('名单人数不能超过1000');
                return false
            }
            if (this.clockShowPresetTitle == '') {
                this.$message('名单标题不可以为空');
                return false
            }
            if (this.clockShowPresetContent == '') {
                this.$message('预存名单不可以为空');
                return false
            }
            // 添加
            if (this.nameId == '') {
                const {
                    msg,
                    status
                } = await clockPresetsAdd({
                    "clockPresetTitle": this.clockShowPresetTitle,
                    "clockPresetContent": this.clockShowPresetContent
                })
                if (status == 1) {
                    this.$message(msg);
                    this.clockPresetsList()
                }
                this.$message(msg);
                this.addNameListDrawer = false;
            }
            // 编辑
            if (this.nameId != '') {
                const {
                    msg,
                    status
                } = await clockPresetsUpdate({
                    "clockPresetTitle": this.clockShowPresetTitle,
                    "clockPresetContent": this.clockShowPresetContent,
                    "id": this.id
                })
                if (status == 1) {
                    this.clockPresetsList()
                }
                this.$message(msg);
                this.addNameListDrawer = false;
            }
        },
        openCus() {
            this.copyShowWriting = this.copywriting;
            this.copyShowImage = this.copyimage;
            this.customizeDrawer = true;
        },
        // 下载excel模板
        downExam() {
            window.open(serverConfig.baseURL + '/excel/模板.xlsx', '_self')
        },
        sureCoverImgFun() {
            this.copywriting = this.copyShowWriting;
            this.copyimage = this.copyShowImage;
            this.customizeDrawer = false;
        },
        openNameListDrawerFun() {
              // 如果名单为空，添加默认的"李某某"和"王某某"
            if (!this.packetData || this.packetData.length === 0) {
                this.packetData = ["李某某", "王某某"];
                this.nameListLength = 2;
                this.people_num = 2;
            }
            // 弹框赋值
            this.nameShowContent = this.packetData.join()
            this.openNameListDrawer = true;
        },
        emptyName() {
            this.clockShowPresetContent = ''
        },
        // 导入
        importExcel(event) {
            var that = this;
            this.selectedFile = event.target.files[0];
            let lastArr = this.selectedFile.name.split('.')

            if (lastArr[1] != "xls" && lastArr[1] != "xlsx") {
                this.$message('文件格式不正确');
                return;
            }

            const loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            var parm = {
                file: this.selectedFile,
                type: 'modularFile'
            }
            axios.post(serverConfig.baseURL + '/file/uploadFileExcel', parm, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Token': localStorage.getItem("token")
                }
            })
                .then(response => {
                    loading.close();
                    var data = response.data
                    if (that.nameAddType == 1) {
                        if (data.status == 1) {
                            that.nameShowContent = data.data;
                            let arr = this.nameShowContent.split(/[\s+,，；;]/g);
                            arr = arr.filter(item => item != "")
                            that.onlyNameArr = arr

                        } else {
                            this.$message(response.data.msg);
                        }
                    } else {
                        if (data.status == 1) {
                            that.fzValue = data.data;
                        } else {
                            this.$message(response.data.msg);
                        }
                    }
                    that.importVisible = false;

                })
                .catch(error => {
                    loading.close();
                    console.log('上传error', error);
                });

        },
        customizeClose() {
            this.customizeDrawer = false;
        },
        // 上传自定义封面
        uploadCopyImage(event) {
            this.selectedFile = event.target.files[0];
            var pettern = /^image/;
            if (!pettern.test(this.selectedFile.type)) {
                this.$message('文件格式不正确');
                return;
            }
            if (this.selectedFile.size / 1048576 > 5) {
                this.$message('图片大小小于5M');
            }
            const loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            var parm = {
                file: this.selectedFile,
                type: 'modularImg'
            }
            axios.post(serverConfig.baseURL + '/file/uploadFile', parm, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Token': localStorage.getItem("token")
                }
            })
                .then(response => {
                    loading.close();
                    var data = response.data
                    if (data.status == 1) {
                        this.copyShowImage = data.msg;
                    } else {
                        this.$message(response.data.msg);
                    }
                })
                .catch(error => {
                    loading.close();
                    console.log('上传error', error);
                });
        },
        delCopyImage() {
            this.copyShowImage = ''
        },
        clearName() {
            this.nameShowContent = '';
        },
        nameListClose() {
            this.openNameListDrawer = false;
        },
        importClose() {
            this.importVisible = false;
        },
        addNameDrawer() {
            this.addNameListDrawer = false;
        },
        closeAddNameDrawer() {
            this.addNameListDrawer = false;
        },
        nameListDrawerFun() {
            this.nameListDrawer = false;
        },
        // 复制填表项
        copyThisSignField(sonIndex, fatherIndex) {
            var data = JSON.parse(JSON.stringify(this.listList[fatherIndex].signField[sonIndex]));
            this.listList[fatherIndex].signField.splice(sonIndex + 1, 0, data)
        },
        // 月截止日期处理
        endMonthFunFirst(e) {
            this.monthDay = e;
            this.formClock.dayOfDate = e;
        },
        endMonthFunSecond(e) {
            var str = this.endMonthArr2[e].label;
            this.formClock.timeOfDay = str + ':' + this.endMonthArr2[this.monthMinute].label
        },
        endMonthFunThird(e) {
            var str = this.endMonthArr3[e].label;
            this.formClock.timeOfDay = this.endMonthArr2[this.monthHour].label + ':' + str
        },
        // 周截止日期处理
        endWeekFunFirst(e) {
            this.weekDay = e;
            this.formClock.dayOfDate = e;
        },
        clockMultiPeriodSwitchFn(e) {
            this.formClock.multiPeriodSwitch = e;
            if (e == 2) {
                this.formClock.clockInTimeSlot.forEach((item, index) => {
                    if (index >= 1) {
                        item.ifDel = 1
                    }
                })
            }
        },
        // 添加时间段
        addTimes() {
            var _json = {
                startTime: "00:00",
                endTime: "23:59",
                startAndEnd: ['00:00', '23:59'],
                ifDel: 2,
                randomDecimal: Date.now(),
            }
            this.formClock.clockInTimeSlot.push(_json)
            this.$forceUpdate()
        },
        timesDel(idx) {
            var l = 0;
            this.formClock.clockInTimeSlot.forEach((item) => {
                if (item.ifDel == 2) {
                    l++
                }
            })
            if (l == 1) {

                this.$message('至少保留一个时间段');
                return false
            }
            this.formClock.clockInTimeSlot[idx].ifDel = 1;
            this.$forceUpdate()
        },
        // 时间段选择
        clockInTimeSlot(e, idx) {
            this.formClock.clockInTimeSlot[idx].startAndEnd = e;
            this.formClock.clockInTimeSlot[idx].startTime = e[0];
            this.formClock.clockInTimeSlot[idx].endTime = e[1];
        },

        clockLocationFn(e) {
            this.formClock.clockLocationStatus = e;
            this.addMapType = 1;
        },

        clockRangeChange(e) {
            this.formClock.clockRange = e;
        },

        supplyFn(e) {
            console.log(e)
            this.formClock.clockSupplyStatus = e;
        },

        // 日期多选
        multipleDateSure(e) {
            this.customDateArr = e;
            this.formClock.customDate = e.join(',')
        },
        // -打卡频率
        clickin(e) {
            this.CheckInFrequency.forEach(item => {
                if (item.value == e) {
                    this.selectData = item.label;
                }
            })

            this.selectFrequency = e;
            this.formClock.clockFrequencyType = e;
            // 每月
            if (e == 1) {
                this.formClock.timeOfDay = '20:00';
                // 日期处理
                this.lastDayOfMonth = this.lastDayOfMonth.slice(-2);
                // 如果选择了开始时间
                var beginTime = this.activityDetail.beginTime;
                if (beginTime) {
                    var year = beginTime.substring(0, 4);
                    var month = beginTime.substring(5, 7);
                    const lastDay = new Date(year, month, 0).getDate();
                    this.lastDayOfMonth = lastDay;
                }
                this.formClock.dayOfDate = this.lastDayOfMonth;
                this.monthDay = Number(this.lastDayOfMonth);
                this.monthHour = 20;
                this.monthMinute = 0;
                this.endMonthValue = this.formClock.dayOfDate + '号 ' + this.formClock.timeOfDay;
            }
            // 每周
            if (e == 2) {
                this.formClock.timeOfDay = '20:00';
                this.formClock.dayOfDate = '6';
                this.weekDay = 6;
                this.weekHour = 20;
                this.weekMinute = 0;
                this.endWeekValue = '周' + this.weekChineseNumbers[this.formClock.dayOfDate] + ' ' + this.formClock.timeOfDay;
            }
            // 每天
            if (e == 3) {
                this.formClock.clockFrequency = '0,1,2,3,4,5,6'
            }
            // 法定工作日，法定节假日，自定义周几打卡，自定义日期打卡，一次性打卡 设置一样

        },
        candidateChange(e) {
            if (this.selectFrequency == 6) {
                this.formClock.clockFrequency = e.join(',')
            }
            if (this.selectFrequency == 3) {
                this.formClock.clockFrequency = '0,1,2,3,4,5,6'
            }
        },
        clockMaxSwitchFn(e) {
            this.formClock.clockMaxSwitch = e;
            if (e == 2) {
                this.formClock.clockMaxNum = 1;
            }
        },
        checkinRangeChange(e) {
            this.checkinrange = e;
        },
        signInfoIsOpenFun(e) {
            this.signInfoStatus = e;
            this.activityDetail.signInfoStatus = e;
        },
        signChange(e) {
            this.updateSignInfo = e;
        },
        deadlineTimeFun(e) {
            this.deadline = e;
            this.activityDetail.registrationtime = e[0]
            this.activityDetail.endregistrationtime = e[1]
        },
        deadCancelTimeFun(e) {
            this.deadCancelline = e;
            this.activityDetail.removeSignBeginTime = e[0]
            this.activityDetail.removeSignEndTime = e[1]
        },
        actStartAndEndTimeFun(e) {
            this.actStartAndEndTime = e;
            this.activityDetail.beginTime = e[0]
            this.activityDetail.endTime = e[1]
        },
        removeSignChange(e) {
            this.removeSignStatus = e;
            this.activityDetail.removeSignStatus = e
        },
        addInp(item, index, fatherIndex) {
            var inp = {
                value: ''
            }
            this.listList[fatherIndex].signField[index].content.push(inp)
            this.$forceUpdate()
        },
        // 删除添加项
        delInp(item, index, indexIdx, listIndex) {
            this.listList[listIndex].signField[indexIdx].content.splice(index, 1)
            this.$forceUpdate()
        },
        // 是否必填
        isRequiredChange(e, sonIndex, fatherIndex) {
            this.listList[fatherIndex].signField[sonIndex].isRequired = (e == true ? 1 : 0);
        },
        // 是否公开
        isOpenChange(e, sonIndex, fatherIndex) {
            this.listList[fatherIndex].signField[sonIndex].isOpen = (e == true ? 1 : 0);
        },
        // 是否重复
        isUniqueCheckChange(e, sonIndex, fatherIndex) {
            this.listList[fatherIndex].signField[sonIndex].isUniqueCheck = (e == true ? 1 : 0);
        },
        // 日期格式
        bindValidateTimePickerChange(e, sonIndex, fatherIndex) {
            this.validateIndex = e;
            this.listList[fatherIndex].signField[sonIndex].timeSelectType = this.validateIndex;
        },
        // 省市区
        bindValidateAreaPickerChange(e, sonIndex, fatherIndex) {
            this.validateIndex = e;
            this.listList[fatherIndex].signField[sonIndex].areaSelectType = this.validateIndex;
        },
        // 打开抽屉
        openfieldList() {
            this.formDrawerShow = true;
        },


        openFullScreen2() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(() => {
                loading.close();
            }, 2000);
        },
        // 上传文件
        handleFileUpload(event, idx) {
            var that = this;
            this.modulCommonIndex = idx;
            this.selectedFile = event.target.files;
            // 加载中
            const loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            for (let i = 0; i < this.selectedFile.length; i++) {
                let name = this.selectedFile[i].name;
                let size = this.selectedFile[i].size;
                // 判断后缀名
                let lastArr = this.selectedFile[i].name.split('.')
                if (lastArr[1] != "pdf" && lastArr[1] != "ppt" && lastArr[1] !=
                    "doc" && lastArr[1] != "docx" && lastArr[1] != "xls" && lastArr[1] != "xlsx" && lastArr[1] != "zip") {
                    loading.close();
                    event.target.value = '';
                    this.$message('文件格式不正确');
                    return;
                } else {
                    if (this.selectedFile[i].size / 1048576 > 10) {
                        loading.close();
                        event.target.value = '';
                        this.$message('请上传大小不超过10MB文件');
                        break;
                    } else {
                        var parm = {
                            file: this.selectedFile[i],
                            type: 'modularFile'
                        }
                        axios.post(serverConfig.baseURL + '/file/uploadFile', parm, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'Access-Token': localStorage.getItem("token")
                            }
                        })
                            .then(response => {
                                loading.close();
                                if (response.data.status == 1) {
                                    var _json = {
                                        name: name,
                                        size: size,
                                        fileUrl: response.data.msg,
                                        lastName: lastArr[1],
                                    }
                                    that.modularList[this.modulCommonIndex].info.filesArr.push(_json);

                                }
                            })
                            .catch(error => {
                                event.target.value = '';
                                loading.close();
                                console.log('err:', error);
                            });
                    }
                }
            }

        },
        // 上传音频
        handleMpThreeUpload(event, idx) {
            var that = this;
            this.modulCommonIndex = idx;
            this.selectedFile = event.target.files;

            // 加载中
            const loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            for (let i = 0; i < this.selectedFile.length; i++) {
                let name = this.selectedFile[i].name;
                let size = this.selectedFile[i].size;
                // 判断后缀名
                let lastArr = this.selectedFile[i].name.split('.')
                if (lastArr[1] != "mp3") {
                    loading.close();
                    event.target.value = '';
                    this.$message('文件格式不正确');
                    return;
                } else {
                    if (this.selectedFile[i].size / 1048576 > 10) {
                        loading.close();
                        event.target.value = '';
                        this.$message('请上传大小不超过10MB文件');
                        break;
                    } else {
                        var parm = {
                            file: this.selectedFile[i],
                            type: 'modularMP3'
                        }

                        axios.post(serverConfig.baseURL + '/file/uploadFile', parm, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'Access-Token': localStorage.getItem("token")
                            }
                        })
                            .then(response => {
                                loading.close();
                                if (response.data.status == 1) {
                                    var _json = {
                                        name: name,
                                        size: size,
                                        fileUrl: response.data.msg,
                                        lastName: lastArr[1],
                                    }
                                    that.modularList[this.modulCommonIndex].info.filesArr.push(_json);

                                }
                            })
                            .catch(error => {
                                loading.close();
                                console.log('err:', error);
                            });
                    }
                }
            }
        },


        // 上传视频
        handleMpFourUpload(event, idx) {
            var that = this;
            this.modulCommonIndex = idx;
            this.selectedFile = event.target.files[0];
            let lastArr = this.selectedFile.name.split('.')
            if (lastArr[1] != "mp4") {
                this.$message('文件格式不正确');
                event.target.value = '';
                return;
            }
            if (this.selectedFile.size / 1048576 > 10) {
                this.$message('请上传大小不超过10MB文件');
                event.target.value = '';
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: '上传中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            var parm = {
                file: this.selectedFile,
                type: 'modularMP4'
            }
            axios.post(serverConfig.baseURL + '/file/uploadFile', parm, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Token': localStorage.getItem("token")
                }
            })
                .then(response => {
                    loading.close();
                    that.modularList[idx].info.fileUrl = response.data.msg
                    that.modularList[idx].info.name = that.selectedFile.name
                    that.modularList[idx].info.size = that.selectedFile.size
                    that.modularList[idx].info.lastName = lastArr[1]
                })
                .catch(error => {
                    loading.close();
                    console.log('图片上传失败', error);
                });
        },
        // 上传图片
        handleImgUpload(event, idx) {
            this.modulCommonIndex = idx;
            this.selectedFile = event.target.files;
            var pettern = /^image/;
            for (let i = 0; i < 9; i++) {
                if (!pettern.test(this.selectedFile[i].type)) {
                    this.$message('文件格式不正确');
                    event.target.value = '';
                    return;
                }
                if (this.selectedFile[i].size / 1048576 > 5) {
                    this.$message('请上传大小不超过5MB文件');
                    event.target.value = '';
                } else {
                    var parm = {
                        file: this.selectedFile[i],
                        type: 'modularImg'
                    }

                    axios.post(serverConfig.baseURL + '/file/uploadFile', parm, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Access-Token': localStorage.getItem("token")
                        }
                    })
                        .then(response => {
                            if (response.data.status == 1) {
                                this.modularList[idx].info.imgarr.push(response.data.msg);
                            }
                        })
                        .catch(error => {
                            event.target.value = ''
                            console.log('err:', error);
                        });
                }

            }

        },
        // 上传小图
        handleSmallImgUpload(event, idx) {
            this.modulCommonIndex = idx;
            // 9个
            const imgCounts = this.modularList[idx].info.imgarr.length;
            const theRest = 9 - imgCounts;
            if (event.target.files.length > theRest) {
                this.$message('只能上传9张小图');
                return;
            }
            this.selectedFile = event.target.files;
            var pettern = /^image/;
            for (let i = 0; i < 9; i++) {
                if (!pettern.test(this.selectedFile[i].type)) {
                    this.$message('文件格式不正确');
                    return;
                }
                if (this.selectedFile[i].size / 1048576 > 5) {
                    this.$message('图片大小小于5M');
                } else {
                    var parm = {
                        file: this.selectedFile[i],
                        type: 'modularImg'
                    }

                    axios.post(serverConfig.baseURL + '/file/uploadFile', parm, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Access-Token': localStorage.getItem("token")
                        }
                    })
                        .then(response => {
                            if (response.data.status == 1) {
                                this.modularList[idx].info.imgarr.push(response.data.msg);
                            }
                        })
                        .catch(error => {
                            event.target.value = ''
                            console.log('err:', error);
                        });
                }

            }
        },
        submitUploadBigImage() {
            const formData = new FormData();
            formData.append('image', this.selectedFile);
            var parm = {
                file: this.selectedFile,
                type: 'modularImg'
            }

            axios.post(serverConfig.baseURL + '/file/uploadFile', parm, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Token': localStorage.getItem("token")
                }
            })
                .then(response => {
                    console.log('图片上传成功', response);

                })
                .catch(error => {
                    console.log('图片上传失败', error);
                });
        },
        anonymousFun(e) {
            this.isanonymous = e;
        },
        // 点赞
        likeFun(e) {
            this.activityDetail.thumbs_up = e;
            console.log(this.activityDetail.thumbs_up, "点赞");
        },
        // 签名
        autographFun(e) {
            this.autographSwitch = e;
            this.activityDetail.autographSwitch = e;
            if (e == 2) {
                this.activityDetail.autograph = null;
            }
        },
        anonymouspartFun(e) {
            this.anonymousparticipation = e;
        },
        commentFun(e) {
            this.commentStatus = e;
        },
        thumbsUpFun(e) {
            this.thumbs_up = e;
            this.activityDetail.thumbs_up = e;
        },
        isCommentFun(e) {
            this.is_comment = e;
        },

        isScoreFun(e) {
            this.is_score = e;
        },
        isDestinationFun(e) {
            this.is_destination = e;
        },
        clockRemindFun(e) {
            this.formClock.clockRemindStatus = e;
        },
        // 打卡提醒时间
        clockTime(e) {
            this.formClock.remindTime = e
        },
        // 表单项上移下移删除
        topNuoPng(item, index, type, listIdx) {
            var data = []
            if (type == 1) {
                data = this.listList
            } else if (type == 2) {
                if (index == 1) {
                    return false
                }
                data = this.listList[listIdx].signField
            } else if (type == 3) {
                data = this.modular
            }
            if (index == 0) {
                return false
            }
            //在上一项插入该项
            data.splice(index - 1, 0, (data[index]));
            //删除后一项
            data.splice(index + 1, 1);

        },
        // 下移
        bottomNuoPng(item, index, type, listIdx) {
            var data = []
            if (type == 1) {
                data = this.listList
            } else if (type == 2) {
                data = this.listList[listIdx].signField
            } else if (type == 3) {
                data = this.modular
            }

            if (index == data.length - 1) {
                return false
            }
            //在下一项插入该项
            data.splice(index + 2, 0, (data[index]));
            // 删除前一项
            data.splice(index, 1);

        },
        // 删除表单项
        delMuKuai(itm, ind, idx) {
            this.indexIdx = idx
            if (this.selectType == 'update') {
                itm['ifDel'] = 1;
                this.delListInfo.push(itm);
            }
            this.listList[this.indexIdx].signField.splice(ind, 1)
        },
        // 大图上移下移
        upBigImg(index, fatherIndex) { // 上移

            if (index == 0) {
                this.$message({
                    message: '已经是第一项',
                    type: 'warning'
                });
                return false;
            }
            //在上一项插入该项
            this.modularList[fatherIndex].info.imgarr.splice(index - 1, 0, (this.modularList[fatherIndex].info.imgarr[index]));
            //删除后一项
            this.modularList[fatherIndex].info.imgarr.splice(index + 1, 1);

        },
        downBigImg(index, fatherIndex) { // 下移

            if (index == this.modularList[fatherIndex].info.imgarr.length - 1) {
                this.$message({
                    message: '已经是最后一项',
                    type: 'warning'
                });
                return false;
            }
            //在下一项插入该项
            this.modularList[fatherIndex].info.imgarr.splice(index + 2, 0, (this.modularList[fatherIndex].info.imgarr[index]));
            // 删除前一项
            this.modularList[fatherIndex].info.imgarr.splice(index, 1);

        },
        // 大图删除
        delBigImg(index, fatherIndex) {
            this.modularList[fatherIndex].info.imgarr.splice(index, 1);
        },
        // 小图删除
        delSmallPic(index, fatherIndex) {
            this.modularList[fatherIndex].info.imgarr.splice(index, 1);
        },
        // 文件删除
        delFiles(index, fatherIndex) {
            this.modularList[fatherIndex].info.filesArr.splice(index, 1);
        },

        //选择位置
        openAddress(idx) {
            this.addMapType = 1;
            this.addressDialog = true
            this.addressIdx = idx
        },
        openMap(idx) {
            this.modulCommonIndex = idx;
            this.addMapType = 2;
            this.addressDialog = true
            this.addressIdx = idx
        },
        openJoininAddress() {
            this.addMapType = 3;
            this.addressDialog = true
        },

        subAddress() {
            window.addEventListener('message', (event) => {
                // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
                const loc = event.data;
                // _this.addressData = []
                if (loc && loc.module == 'locationPicker') { //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
                    this.address = loc.poiaddress
                    this.poiname = loc.poiname
                    this.latitude = loc.latlng.lat
                    this.longitude = loc.latlng.lng
                }
            }, false);
        },
        //地图选点确定
        submitMap() {
            if (this.address == null || this.latitude == null || this.longitude == null) {
                this.$message.error('请先选择地址！');
                return;
            }

            this.addressDialog = false
            // 模块
            if (this.addMapType == 2) {
                this.modularList[this.modulCommonIndex].info.address = this.address;
                this.modularList[this.modulCommonIndex].info.latitude = this.latitude;
                this.modularList[this.modulCommonIndex].info.longitude = this.longitude;
                this.modularList[this.modulCommonIndex].info.name = this.poiname;
                this.modularList[this.modulCommonIndex].location = {
                    lng: this.longitude,
                    lat: this.latitude
                }
            }
            // 设置
            if (this.addMapType == 3) {
                this.specifyaddress = this.address;
                this.deliveryaddress = `${this.latitude},${this.longitude}`;

            }
            // 打卡
            if (this.addMapType == 1) {
                var info = {
                    name: this.poiname,
                    address: this.address,
                    latitude: this.latitude,
                    longitude: this.longitude,
                }
                this.formClock.clockLocationInfo = JSON.stringify(info);
                this.formClock.address = this.address;
            }
        },

        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(() => {
                    done();
                })
                .catch(() => { });
        },
        formDrawerClose() {
            this.formDrawerShow = false;
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        submitUpload() {
            this.$refs.upload.submit();
        },

        handlePreview(file) {
            console.log(file);
        },

        getLastDayOfMonth(date = new Date()) {
            // 使用示例
            // 创建一个新的日期对象，设置为下一个月的第一天
            let nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1);

            // 减去一天，即得到当前月的最后一天
            let lastDay = new Date(nextMonth - 1);

            // 返回结果，根据需要可以返回不同的格式
            // 这里返回的是日期对象的字符串形式
            return lastDay.toISOString().split('T')[0]; // 如果你想要的是 YYYY-MM-DD 格式

            // 或者直接返回日期对象
            // return lastDay;
        },
        // 对象数组进行去重
        uniqueBy(a, key) {
            const seen = new Set();
            return a.filter((item) => {
                const k = key(item);
                return seen.has(k) ? false : seen.add(k);
            });
        },
        getClickInfo(address) {
            this.markLocation.lat = address.point.lat;
            this.markLocation.lng = address.point.lng;
        },
        searchMap(address) {
            // 创建地址解析器实例，平时用不了，加个window完美胡恶化！
            let myGeo = new window.BMap.Geocoder();
            // 因为下面那个方法是异步的，你又不能在里面this，
            //所以先在外面把this赋值给一个变量self，然后在里面就可以接了！
            let self = this;
            new myGeo.getPoint(address, function (e) {
                self.markLocation.lat = e.lat;
                self.markLocation.lng = e.lng;
            });
        },
        checkDetail(e) {
            console.log(e, 'uuuuuu')
        },
        // 模块上移下移删除
        moveUp(index) {
            if (index == 0) {
                this.$message({
                    message: '已经是第一项',
                    type: 'warning'
                });
                return false;
            }
            //在上一项插入该项
            this.modularList.splice(index - 1, 0, (this.modularList[index]));
            //删除后一项
            this.modularList.splice(index + 1, 1);
        },
        moveDown(index) {
            if (index == this.modularList.length - 1) {
                this.$message({
                    message: '已经是最后一项',
                    type: 'warning'
                });
                return false;
            }
            //在下一项插入该项
            this.modularList.splice(index + 2, 0, (this.modularList[index]));
            // 删除前一项
            this.modularList.splice(index, 1);
        },
        delmodular(item, index) {
            var that = this;
            this.$confirm('是否确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (item.id != null && item.id != undefined && that.selectType == "update") {
                    that.modularDelIds.push(item.id)
                }
                that.modularList.splice(index, 1)
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 查看大图
        seeBigImg(src) {
            this.previewImgSrc = src;
            this.previewImgShow = true;
        },
        hidePreview() {
            this.previewImgShow = false
        },

        timestampToTime(date) {
            if (date == "" || !date) {
                return "";
            }
            var date2 = new Date(date);
            var y = date2.getFullYear();
            var m = date2.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = date2.getDate();
            d = d < 10 ? ('0' + d) : d;
            var h = date2.getHours();
            h = h < 10 ? ('0' + h) : h;
            var minute = date2.getMinutes();
            minute = minute < 10 ? ('0' + minute) : minute;
            var second = date2.getSeconds();
            second = second < 10 ? ('0' + second) : second;
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;

        },

    },
    computed: {
        ...mapState(["isOpenShare"]),
        setMb() {
            return function (size, fileType) {
                if (size == '') {
                    return ''
                } else {
                    let infoSize = size / 1048576
                    if (fileType == "mp3" || fileType == "MP3" || fileType == "Mp3" || fileType == "mP3") {
                        return "音频大小：" + (Math.floor(infoSize) == 0 ? Math.floor(size / 1024) + "KB" : Math.floor(
                            infoSize) + "MB")
                    } else if (fileType == "mp4" || fileType == "MP4" || fileType == "Mp4" || fileType == "mP4") {
                        return "视频大小：" + (Math.floor(infoSize) == 0 ? Math.floor(size / 1024) + "KB" : Math.floor(
                            infoSize) + "MB")
                    } else {
                        return "文件大小：" + (Math.floor(infoSize) == 0 ? Math.floor(size / 1024) + "KB" : Math.floor(
                            infoSize) + "MB")
                    }
                }
            }
        },
        setKb() {
            return function (size, fileType) {
                if (size == "") {
                    return ''
                } else if (size == 0) {
                    return "文件大小：" + 0 + "KB"
                } else {
                    let infoSize = size / 1024
                    if (fileType == "mp3" || fileType == "MP3" || fileType == "Mp3" || fileType == "mP3") {
                        return "音频大小：" + Math.floor(infoSize) + "KB"
                    } else if (fileType == "mp4" || fileType == "MP4" || fileType == "Mp4" || fileType == "mP4") {
                        return "视频大小：" + Math.floor(infoSize) + "KB"
                    } else {
                        return "文件大小：" + Math.floor(infoSize) + "KB"
                    }
                }
            }
        },
        setB() {
            return function (size, fileType) {
                if (size == "") {
                    return ''
                } else if (size == 0) {
                    return "文件大小：" + 0 + "B"
                } else {
                    let infoSize = size
                    if (fileType == "mp3" || fileType == "MP3" || fileType == "Mp3" || fileType == "mP3") {
                        return "音频大小：" + Math.floor(infoSize) + "B"
                    } else if (fileType == "mp4" || fileType == "MP4" || fileType == "Mp4" || fileType == "mP4") {
                        return "视频大小：" + Math.floor(infoSize) + "B"
                    } else {
                        return "文件大小：" + Math.floor(infoSize) + "B"
                    }
                }
            }
        },
    },
};
</script>

<template>
    <Layout>

        <div class="row">
            <div class="outBox">
                <div class="bigTitle">{{ selectType == 'add' ? '创建' : '编辑' }}{{ activeBuildTitle }}</div>
                <div class="blockBox">
                    <div class="b-marT-10 centerTitle">
                        <el-input v-model="activityDetail.name" placeholder="请输入标题"
                            style="text-align: center"></el-input>
                    </div>
                    <div class="b-marT-10"
                        :class="{ 'zsy': modularList.length <= 1, 'nozsy': modularList.length >= 2 }">
                        <el-input type="textarea" class="zsy-inner" v-model="activityDetail.content" placeholder="请输入内容"
                            rows="5"></el-input>
                    </div>
                    <div class="b-marT-10 centerTitle">
                        <div class="autograph-row">
                            <span class="autograph-label">发布人签名</span>
                            <div class="autograph-input-wrap">
                                <el-input style="text-align: right" v-model="activityDetail.autograph"
                                    placeholder="请输入签名" class="autograph-input" />
                            </div>
                        </div>
                    </div>
                    <!-- todo 详情页展示列表 -->

                    <div v-for="(item, index) in modularList" :key="index">
                        <!-- 内容 -->
                        <div class="block-for-box" v-if="item.type == 1">
                            <div class="flex-depart-center">
                                <div class="tl-item bf-item flex-depart-left">
                                    <el-input class="f-ipt" v-model="item.info.title" placeholder="请输入标题"></el-input>
                                </div>
                                <div class="f-handle tr-item">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                                        alt="" @click="moveUp(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                                        alt="" @click="moveDown(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                                        alt="" @click="delmodular(item, index)">
                                </div>
                            </div>
                            <div class="b-marT-10">
                                <el-input type="textarea" v-model="item.info.value" placeholder="请输入内容"
                                    rows="5"></el-input>
                            </div>
                        </div>
                        <!-- 大图 -->
                        <div class="block-for-box" v-if="item.type == 9">
                            <div class="flex-depart-center">
                                <div class="tl-item bf-item flex-depart-left">
                                    <el-input class="f-ipt" v-model="item.info.value" placeholder="大图"></el-input>
                                </div>
                                <div class="f-handle tr-item">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                                        alt="" @click="moveUp(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                                        alt="" @click="moveDown(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                                        alt="" @click="delmodular(item, index)">
                                </div>
                            </div>
                            <div class="b-marT-10" v-for="(imgItem, imgIndex) in item.info.imgarr" :key="imgIndex">
                                <div class="flex-depart-top">
                                    <div class="big-img">
                                        <!--                                        <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/5c2333976171b.jpg" alt="">-->
                                        <img :src="imageUrl + imgItem" alt="">
                                    </div>
                                    <div class="flex-depart-column-top-left b-handle">
                                        <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                                            alt="" @click="upBigImg(imgIndex, index)">
                                        <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                                            alt="" @click="downBigImg(imgIndex, index)">
                                        <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                                            alt="" @click="delBigImg(imgIndex, index)">
                                    </div>
                                </div>
                            </div>
                            <div class="addSmallBtn b-marT-10" v-if="item.info.imgarr.length < 9">
                                <input class="updateFileBtn" type="file" id="imageInput" multiple accept="image/*"
                                    @change="event => handleImgUpload(event, index)" />
                                <i class="el-icon-circle-plus"></i>&nbsp;点击上传大图
                            </div>
                        </div>
                        <!-- 小图 -->
                        <div class="block-for-box" v-if="item.type == 3">
                            <div class="flex-depart-center">
                                <div class="tl-item bf-item flex-depart-left">
                                    <el-input class="f-ipt" v-model="item.info.value" placeholder="小图"></el-input>
                                </div>
                                <div class="f-handle tr-item">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                                        alt="" @click="moveUp(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                                        alt="" @click="moveDown(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                                        alt="" @click="delmodular(item, index)">
                                </div>
                            </div>
                            <div class="b-marT-10 flex-depart-left-warp ">
                                <div class="smallImgbox seeBigImgHover" v-for="(imgItem, imgIndex) in item.info.imgarr"
                                    :key="imgIndex">
                                    <div class="handle2">
                                        <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-chakandatu.svg"
                                            @click="seeBigImg(imgItem)" alt="">
                                        <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchuxiaotu.svg"
                                            @click="delSmallPic(imgIndex, index)" alt="">
                                    </div>
                                    <div class="imgBg"
                                        :style="{ background: `url(${imageUrl + imgItem}) no-repeat center`, backgroundSize: 'cover' }">
                                    </div>
                                </div>
                                <div class="upl-smallImg" v-if="item.info.imgarr.length < 9">
                                    <input class="updateFileBtn" type="file" id="imageInput2" multiple accept="image/*"
                                        @change="event => handleSmallImgUpload(event, index)" />
                                    <i class="el-icon-circle-plus"></i>
                                    <span>上传小图</span>
                                </div>
                            </div>
                        </div>
                        <!-- 地点 -->
                        <div class="block-for-box" v-if="item.type == 4">
                            <div class="flex-depart-center">
                                <div class="tl-item bf-item flex-depart-left">
                                    <el-input class="f-ipt" v-model="item.info.value" placeholder="地址"></el-input>
                                </div>
                                <div class="f-handle tr-item">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                                        alt="" @click="moveUp(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                                        alt="" @click="moveDown(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                                        alt="" @click="delmodular(item, index)">
                                </div>
                            </div>
                            <!--                            <div class="b-marT-10" v-show="item.info.address">-->
                            <!--                                <baidu-map class="map" @click="getClickInfo" :center="item.location">-->
                            <!--                                    &lt;!&ndash; 右上角比例尺控件 &ndash;&gt;-->
                            <!--                                    <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>-->
                            <!--                                    &lt;!&ndash; 右上角缩放控件 &ndash;&gt;-->
                            <!--                                    <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>-->
                            <!--                                    &lt;!&ndash; 右下角加入定位控件 &ndash;&gt;-->
                            <!--                                    <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>-->
                            <!--                                    &lt;!&ndash; bm-marker 就是标注点，定位在 markLocation 的经纬度上 &ndash;&gt;-->
                            <!--                                    <bm-marker :position="item.location" @click="checkDetail"></bm-marker>-->
                            <!--                                </baidu-map>-->
                            <!--                            </div>-->

                            <div class="b-marT-10">
                                <div style="font-weight: bold">{{ item.info.name }}</div>
                                <div>{{ item.info.address }}</div>
                                <el-button v-if="!item.info.address" @click="openMap(index)">选择位置</el-button>
                                <el-button v-if="item.info.address" @click="openMap(index)">重新选择</el-button>
                            </div>
                        </div>
                        <!-- 文件 -->
                        <div class="block-for-box" v-if="item.type == 5">
                            <div class="flex-depart-center">
                                <div class="tl-item bf-item flex-depart-left">
                                    <el-input class="f-ipt" v-model="item.info.value" placeholder="文件"></el-input>
                                </div>
                                <div class="f-handle tr-item">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                                        alt="" @click="moveUp(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                                        alt="" @click="moveDown(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                                        alt="" @click="delmodular(item, index)">
                                </div>
                            </div>
                            <div class="b-marT-10">
                                <div class="filesStyle flex-depart-center hoverColor1"
                                    v-for="(fileItem, fileIndex) in item.info.filesArr" :key="fileIndex">
                                    <div class="flex-depart-left">
                                        <img v-if="fileItem.lastName == 'doc'"
                                            :src="imageUrl + '/static/announcement/word.png'" class="Img3">
                                        <img v-else-if="fileItem.lastName == 'docx'"
                                            :src="imageUrl + '/static/announcement/word.png'" class="Img3">
                                        <img v-else-if="fileItem.lastName == 'pdf'"
                                            :src="imageUrl + '/static/announcement/PDF.png'" class="Img3">
                                        <img v-else-if="fileItem.lastName == 'ppt'"
                                            :src="imageUrl + '/static/announcement/PPT.png'" class="Img3">
                                        <img v-else-if="fileItem.lastName == 'xls'"
                                            :src="imageUrl + '/static/index/excel.png'" class="Img3">
                                        <img v-else-if="fileItem.lastName == 'xlsx'"
                                            :src="imageUrl + '/static/index/excel.png'" class="Img3">
                                        <img v-else-if="fileItem.lastName == 'zip'"
                                            src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/zip.svg"
                                            class="Img3">
                                        <span>{{ fileItem.name }}</span>/
                                        <span v-if="fileItem.size / 1024 <= 1">{{ setB(fileItem.size, fileItem.lastName)
                                            }}</span>
                                        <span v-else-if="fileItem.size / 1024 >= 1 && fileItem.size / 1048576 <= 1">{{
                                            setKb(fileItem.size, fileItem.lastName) }}</span>
                                        <span v-else-if="fileItem.size / 1048576 >= 1">{{ setMb(fileItem.size,
                                            fileItem.lastName) }}</span>

                                    </div>
                                    <i class="el-icon-delete del" @click="delFiles(fileIndex, index)"></i>
                                </div>
                            </div>
                            <div class="addSmallBtn b-marT-10">
                                <input class="updateFileBtn" type="file" id="imageInput3" multiple
                                    accept=".xls,.xlsx,.docx,.pdf,.ppt,.zip"
                                    @change="event => handleFileUpload(event, index)" />
                                <i class="el-icon-circle-plus"></i>&nbsp;点击上传文件
                            </div>
                        </div>
                        <!-- 音频 -->
                        <div class="block-for-box" v-if="item.type == 6">
                            <div class="flex-depart-center">
                                <div class="tl-item bf-item flex-depart-left">
                                    <el-input class="f-ipt" v-model="item.info.value" placeholder="音频"></el-input>
                                </div>
                                <div class="f-handle tr-item">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                                        alt="" @click="moveUp(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                                        alt="" @click="moveDown(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                                        alt="" @click="delmodular(item, index)">
                                </div>
                            </div>
                            <div class="b-marT-10">
                                <div class="filesStyle flex-depart-center hoverColor1"
                                    v-for="(fileItem, fileIndex) in item.info.filesArr" :key="fileIndex">
                                    <div class="flex-depart-left" @click="openMusic(fileItem)" style="cursor: pointer">
                                        <img :src="imageUrl + '/static/announcement/MP3.png'" class="Img3">
                                        <span>{{ fileItem.name }}</span>/
                                        <span v-if="fileItem.size / 1024 <= 1">{{ setB(fileItem.size, fileItem.lastName)
                                            }}</span>
                                        <span v-else-if="fileItem.size / 1024 >= 1 && fileItem.size / 1048576 <= 1">{{
                                            setKb(fileItem.size, fileItem.lastName) }}</span>
                                        <span v-else-if="fileItem.size / 1048576 >= 1">{{ setMb(fileItem.size,
                                            fileItem.lastName) }}</span>
                                    </div>
                                    <i class="el-icon-delete del" @click="delFiles(fileIndex, index)"></i>
                                </div>
                            </div>
                            <div class="addSmallBtn b-marT-10">
                                <input class="updateFileBtn" type="file" id="imageInput4" accept=".mp3" multiple
                                    @change="event => handleMpThreeUpload(event, index)" />
                                <i class="el-icon-circle-plus"></i>&nbsp;点击上传音频
                            </div>
                        </div>
                        <!-- 视频 -->
                        <div class="block-for-box" v-if="item.type == 7">
                            <div class="flex-depart-center">
                                <div class="tl-item bf-item flex-depart-left">
                                    <el-input class="f-ipt" v-model="item.info.value" placeholder="视频"></el-input>
                                </div>
                                <div class="f-handle tr-item">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                                        alt="" @click="moveUp(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                                        alt="" @click="moveDown(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                                        alt="" @click="delmodular(item, index)">
                                </div>
                            </div>
                            <div class="b-marT-10" v-if="item.info.fileUrl != ''">
                                <video controls width="450">
                                    <source :src="imageUrl + `${item.info.fileUrl}`" type="video/mp4">
                                    Sorry, your browser doesn't support embedded videos.
                                </video>
                            </div>
                            <div class="addSmallBtn b-marT-10">
                                <input class="updateFileBtn" type="file" id="imageInput5" accept=".mp4"
                                    @change="event => handleMpFourUpload(event, index)" />
                                <i class="el-icon-circle-plus"></i>&nbsp;{{ item.info.fileUrl == '' ? '点击上传视频' : '更改视频'
                                }}
                            </div>
                        </div>

                        <!-- 公众号 -->
                        <div class="block-for-box" v-if="item.type == 10">
                            <div class="flex-depart-center">
                                <div class="tl-item bf-item flex-depart-left">
                                    <el-input class="f-ipt" v-model="item.info.value" placeholder="公众号"></el-input>
                                </div>
                                <div class="f-handle tr-item">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                                        alt="" @click="moveUp(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                                        alt="" @click="moveDown(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                                        alt="" @click="delmodular(item, index)">
                                </div>
                            </div>
                            <div class="b-marT-10">
                                <p>标题</p>
                                <el-input class="f-ipt" v-model="item.info.officialAccountTitle"
                                    placeholder="请输入公众号文章标题"></el-input>
                            </div>
                            <div class="b-marT-10">
                                <p>公众号文章链接</p>
                                <el-input class="f-ipt" v-model="item.info.link" placeholder="请输入公众号文章链接"></el-input>
                            </div>
                        </div>

                        <!-- 视频号 -->
                        <div class="block-for-box" v-if="item.type == 11">
                            <div class="flex-depart-center">
                                <div class="tl-item bf-item flex-depart-left">
                                    <el-input class="f-ipt" v-model="item.info.value" placeholder="视频号"></el-input>
                                </div>
                                <div class="f-handle tr-item">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                                        alt="" @click="moveUp(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                                        alt="" @click="moveDown(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                                        alt="" @click="delmodular(item, index)">
                                </div>
                            </div>
                            <div class="b-marT-10">
                                <p>视频号标题</p>
                                <el-input class="f-ipt" v-model="item.info.videoNumberTitle"
                                    placeholder="请输入视频号标题"></el-input>
                            </div>
                            <div class="b-marT-10">
                                <p>视频号ID</p>
                                <el-input class="f-ipt" v-model="item.info.videoNumberID"
                                    placeholder="请输入以sph开头的视频号ID"></el-input>
                            </div>
                            <div class="b-marT-10">
                                <p>视频ID</p>
                                <el-input class="f-ipt" v-model="item.info.videoId" placeholder="请输入视频ID"></el-input>
                            </div>
                        </div>

                        <!-- 其他小程序 -->
                        <div class="block-for-box" v-if="item.type == 12">
                            <div class="flex-depart-center">
                                <div class="tl-item bf-item flex-depart-left">
                                    <el-input class="f-ipt" v-model="item.info.value" placeholder="其他小程序标题"></el-input>
                                </div>
                                <div class="f-handle tr-item">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                                        alt="" @click="moveUp(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                                        alt="" @click="moveDown(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                                        alt="" @click="delmodular(item, index)">
                                </div>
                            </div>
                            <div class="b-marT-10">
                                <p>标题</p>
                                <el-input class="f-ipt" v-model="item.info.appTitle"
                                    placeholder="请输入小程序展示标题"></el-input>
                            </div>
                            <div class="b-marT-10">
                                <p>小程序APPID</p>
                                <el-input class="f-ipt" v-model="item.info.appid" placeholder="请输入小程序APPID"></el-input>
                            </div>
                            <div class="b-marT-10">
                                <p>小程序页面路径</p>
                                <el-input class="f-ipt" v-model="item.info.pagePath"
                                    placeholder="请输入小程序页面路径"></el-input>
                            </div>

                        </div>

                        <!-- 关联接龙 -->
                        <div class="block-for-box" v-if="item.type == 14">
                            <div class="flex-depart-center">
                                <div class="tl-item bf-item flex-depart-left">
                                    <el-input class="f-ipt" v-model="item.info.value" placeholder="其他小程序标题"></el-input>
                                </div>
                                <div class="f-handle tr-item">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                                        alt="" @click="moveUp(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                                        alt="" @click="moveDown(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                                        alt="" @click="delmodular(item, index)">
                                </div>
                            </div>
                            <div class="b-marT-10 gljl-block flex-depart-center" @click="addgljl(index)"
                                v-for="(fileItem, fileIndex) in item.info.associationActivityId" :key="fileIndex">
                                <div>{{ fileItem.name }}</div>
                                <i class="el-icon-delete del" @click.stop="delRelatedFiles(fileIndex, index)"></i>
                            </div>

                            <div class="b-marT-10 ">
                                <div class="gl-btnStyle" @click="addgljl(index)">点击添加关联接龙</div>
                            </div>


                        </div>

                        <!-- 可复制内容 -->
                        <div class="block-for-box" v-if="item.type == 13">
                            <div class="flex-depart-center">
                                <div class="tl-item bf-item flex-depart-left">
                                    <el-input class="f-ipt" v-model="item.info.value" placeholder="可复制内容"></el-input>
                                </div>
                                <div class="f-handle tr-item">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                                        alt="" @click="moveUp(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                                        alt="" @click="moveDown(index)">
                                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                                        alt="" @click="delmodular(item, index)">
                                </div>
                            </div>
                            <div class="b-marT-10">
                                <el-input type="textarea" v-model="item.info.value" rows="5"
                                    placeholder="请输入可复制内容"></el-input>
                            </div>
                        </div>

                    </div>

                    <!-- todo 详情页展示添加按钮 -->
                    <div class="handle-box flex-depart-left b-marT-10">
                        <div class="flex-depart-left h-item" @click="addModule(0)">
                            <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-zdingyi.svg"
                                alt="">
                            <span>自定义内容</span>
                        </div>
                        <div class="flex-depart-left h-item" @click="addModule(7)">
                            <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-datu.svg"
                                alt="">
                            <span>大图</span>
                        </div>
                        <div class="flex-depart-left h-item" @click="addModule(2)">
                            <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-jiugongge.svg"
                                alt="" style="margin-right: 3px">
                            <span>九宫格图片</span>
                        </div>
                        <div class="flex-depart-left h-item" @click="addModule(3)">
                            <i style="font-size:17px;margin-right: 3px" class="el-icon-location-outline"></i>
                            <span>位置</span>
                        </div>
                        <div class="flex-depart-left h-item" @click="addModule(4)">
                            <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-wenjian.svg"
                                alt="">
                            <span>文件</span>
                        </div>
                        <div class="flex-depart-left h-item" @click="addModule(5)">
                            <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-yinpin.svg"
                                alt="">
                            <span>音频</span>
                        </div>
                        <div class="flex-depart-left h-item" @click="addModule(6)">
                            <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shipin.svg"
                                alt="">
                            <span>视频</span>
                        </div>
                        <div class="flex-depart-left h-item" @click="addModule(8)">
                            <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-gongzhonghao.svg"
                                alt="">
                            <span>公众号</span>
                        </div>
                        <div class="flex-depart-left h-item" @click="addModule(9)">
                            <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shipinhao.svg"
                                alt="">
                            <span>视频号</span>
                        </div>
                        <div class="flex-depart-left h-item" @click="addModule(10)">
                            <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-qitaxiaochegnxu.svg"
                                alt="">
                            <span>其他小程序</span>
                        </div>
                        <div class="flex-depart-left h-item" @click="addModule(12)">
                            <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-guanlian.svg"
                                alt="">
                            <span>关联接龙</span>
                        </div>
                        <div class="flex-depart-left h-item" @click="addModule(11)">
                            <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-kefuzi.svg"
                                alt="">
                            <span>可复制内容</span>
                        </div>
                    </div>
                </div>
                <div class="blockBox" style="position: relative; padding: 10px 15px">
                    <div class="flex-depart-center name-title">
                        <div class="name-title-left">
                            <span>参与名单</span>
                            <span v-if="clockSwitch == 2">（{{ nameListLength }}人）</span>
                            <img src="https://ossfastmake.mustke.com/12jielong/bdJL/yanshi4.0.svg" alt=""
                                style="position: relative; top: 4px" class="yanshiBtn" @click="demonstrate(11)" />
                        </div>
                        <div class="flex-depart-center">
                            <div @click="relayList" style="display: flex;align-items: center; justify-content: center;">
                                <span style="font-size: 28rpx;color: #1877FF;">{{ clockSwitch == 1 ? '不启用' : (nameAddType
                                    == '2' ? '添加分组+名单' : '仅添加名单') }}</span>
                                <i class="el-icon-arrow-right" color="#1877FF"></i>
                            </div>
                            <!-- <span
                class="bjmdBtn"
                @click="editFzNameList"
                v-if="packetData.length && clockSwitch == 2"
                ><i class="el-icon-edit"></i>编辑名单</span
              > -->
                        </div>
                    </div>

                    <div class="flex-depart-center-top" v-if="nameAddType == '2' && clockSwitch == 2">
                        <span>分组：</span>
                        <el-select v-model="pickerNameSelect" placeholder="请选择" @change="selectGrouping">
                            <el-option v-for="(mItem, mIndex) in pickerNameSelectArr" :key="mIndex" :label="mItem.label"
                                :value="mItem.value"></el-option>
                        </el-select>
                    </div>
                    <template v-if="clockSwitch == 2">
                        <div class="jlName" v-if="packetData.length">
                            <div class="listName">
                                <div class="spanDiv" v-for="(item, index) in packetData.slice(
                                    0,
                                    (activityDetail.clockListNumber || 5) * 4 - 1
                                )" :key="index" :style="{
                                    lineHeight:
                                        activityDetail.clockNameNumberSwitch == 1 ? '' : '48px',
                                    width:
                                        activityDetail.clockListNumber === 2
                                            ? 'calc(50% - 8px)'
                                            : activityDetail.clockListNumber === 3
                                                ? 'calc(33.33% - 8px)'
                                                : activityDetail.clockListNumber === 4
                                                    ? 'calc(25% - 8px)'
                                                    : 'calc(20% - 8px)',
                                }">
                                    <span v-if="activityDetail.clockNameNumberSwitch == 1">{{
                                        index + 1
                                        }}</span>
                                    {{ item.length > 4 ? item.substring(0, 4) + "..." : item }}
                                </div>
                                <div class="spanDiv" :style="{
                                    lineHeight:
                                        activityDetail.clockNameNumberSwitch == 1 ? '' : '48px',
                                    width:
                                        activityDetail.clockListNumber === 2
                                            ? 'calc(50% - 8px)'
                                            : activityDetail.clockListNumber === 3
                                                ? 'calc(33.33% - 8px)'
                                                : activityDetail.clockListNumber === 4
                                                    ? 'calc(25% - 8px)'
                                                    : 'calc(20% - 8px)',
                                }" style="
                    width: calc(20% - 8px);
                    background: #ebf3ff;
                    border: 1px dashed #1877ff;
                    cursor: pointer;
                    color: #1877ff;
                  " @click="editFzNameList">
                                    编辑名单
                                </div>
                                <div v-for="n in 8" :key="'empty' + n" class="spanDivEmpty" :style="{
                                    width:
                                        activityDetail.clockListNumber === 2
                                            ? 'calc(50% - 8px)'
                                            : activityDetail.clockListNumber === 3
                                                ? 'calc(33.33% - 8px)'
                                                : activityDetail.clockListNumber === 4
                                                    ? 'calc(25% - 8px)'
                                                    : 'calc(20% - 8px)',
                                }"></div>
                            </div>
                        </div>
                    </template>

                    <div class="name-flex" v-if="clockSwitch == 2 && packetData.length">
                        <div class="flex-left">
                            <div class="count">每排数量</div>
                            <div class="flex-dropdown" v-if="packetData.length">
                                <el-dropdown @command="clockListNumFn">
                                    <span class="el-dropdown-link">
                                        {{ `一排${clockListNumber}个` }}
                                        <i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="item in clockListNumArr" :key="item.value"
                                            :command="item.value">{{
                                            item.label }}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                        <div class="flex-right">
                            预览仅展示{{ activityDetail.clockListNumber }}排
                        </div>
                    </div>
                </div>
                <!-- todo 设置 -->
                <template>
                    <div class="set-out-box">
                        <div class="settingBox b-marT-10 flex-depart-center">
                            <span class="sTitle">点赞</span>
                            <div>
                                <el-radio-group v-removeAriaHidden v-model="activityDetail.thumbs_up" @input="thumbsUpFun">
                                    <el-radio :label="1">开启</el-radio>
                                    <el-radio :label="2">关闭</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                        <!--                        <div class="settingBox b-marT-10 flex-depart-center">-->
                        <!--                            <span class="sTitle">签名</span>-->
                        <!--                            <div>-->
                        <!--                                <el-radio-group v-removeAriaHidden v-model="autographSwitch" @input="autographFun">-->
                        <!--                                    <el-radio :label="1">开启</el-radio>-->
                        <!--                                    <el-radio :label="2">关闭</el-radio>-->
                        <!--                                </el-radio-group>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                    </div>
                </template>
            </div>
        </div>

        <!-- todo 去创建 -->
        <div class="posi-bottom-btn-box flex-depart-center-center">
            <div class="saveDatabox flex-depart-center-center" @click="submit">立即发布</div>
        </div>


        <div style="height: 90px"></div>
        <!--查看大图-->
        <div class="previewImgBox" @click="hidePreview" v-if="previewImgShow == true">
            <i class="closePImg el-icon-circle-close"></i>
            <img class="inner-p-img" :src="imageUrl + previewImgSrc" alt="">
        </div>
        <!--抽屉-表单项弹框 -->
        <el-drawer :visible.sync="formDrawerShow" :direction="direction" size="450px" :withHeader="false"
            :before-close="formDrawerClose">
            <div class="drawerOutBox">
                <div class="drawer-nav-top">
                    <div></div>
                    <span>添加表单项</span>
                    <i class="el-icon-close" @click="formDrawerClose"></i>
                </div>
                <div class="af-title ">通用填写项</div>
                <div class="ty-block flex-depart-center b-marT-10">
                    <div class="ty-b-item" @click="addForm(-1)">
                        <i class="el-icon-circle-plus addFBtn"></i>
                        <div>单行文本</div>
                        <p>姓名、填空等单行文本</p>
                    </div>
                    <div class="ty-b-item" @click="addForm(-4)">
                        <i class="el-icon-circle-plus addFBtn"></i>
                        <div>多行文本</div>
                        <p>可输入多行文字</p>
                    </div>
                </div>
                <div class="ty-block flex-depart-center b-marT-10">
                    <div class="ty-b-item" @click="addForm(-2)">
                        <i class="el-icon-circle-plus addFBtn"></i>
                        <div>单选</div>
                        <p>单向选择</p>
                    </div>
                    <div class="ty-b-item" @click="addForm(-3)">
                        <i class="el-icon-circle-plus addFBtn"></i>
                        <div>多选</div>
                        <p>多项选择</p>
                    </div>
                </div>
                <div class="af-title b-marT-10">常用填写项</div>
                <div class="b-marT-10 cy-box">
                    <div class="cy-item" v-for="(item, index) in formList" :key="item.type"
                        @click="addForm(item.type, index)">
                        <span>{{ item.label }}</span><i class="el-icon-circle-plus addFBtn2"></i>
                    </div>
                </div>
            </div>
        </el-drawer>
        <!--抽屉-名单 -->
        <el-drawer :visible.sync="openNameListDrawer" :direction="direction" size="450px" :withHeader="false"
            :before-close="nameListClose">
            <div class="drawerOutBox">
                <div class="drawer-nav-top">
                    <div></div>
                    <span>添加接龙名单</span>
                    <!-- <i class="el-icon-close" @click="nameListClose"></i> -->
                    <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
                        @click="nameListClose">
                </div>
                <div class="underline"></div>
                <div class="nl-title">姓名名单</div>
                <div class="b-marT-10">
                    <el-input type="textarea" rows="15" v-model="nameShowContent" @input="handlerBlurOnlyName($event)"
                        placeholder="请输入姓名名单" class="textareName"></el-input>
                </div>
                <div style="color: #a5a4a4;line-height: 50px">提示：每个名单用逗号或者换行隔开</div>
                <div class="clockNameNumberSwitchDiv"
                    style="display: flex; justify-content: space-between; align-items: center;">
                    <div style="display: flex; align-items: center;">
                        <el-switch v-model="clockNameNumberSwitch" @change="clockNameNumberSwitchChange($event)"
                            active-color="#1877FF" inactive-color="rgb(230, 230, 230)" active-value="1"
                            inactive-value="2">
                        </el-switch>
                        <div style="margin-left: 6px;">添加编号/学号</div>
                    </div>
                    <div>合计:{{ people_num }}人</div>
                </div>
                <div class="flex-depart-center b-marT-10">
                    <div class="daoru" @click="importVisible = true">从Excel导入</div>
                    <div class="qingkong" @click="clearName"><i class="el-icon-delete"></i>清空内容</div>
                </div>
                <div class="flex-depart-center b-marT-20 addnameBtns">
                    <el-button round @click="openNamelistFun">预存名单</el-button>
                    <el-button round type="primary" @click="sureAddNameList">确定</el-button>
                </div>

                <div class="jl-box" :style="{ paddingBottom: '0' }"
                    style="margin-bottom: 0 !important;margin-top: 0;background-color: transparent !important;"
                    v-if="onlyNameArr.length > 0">
                    <div class="jlName" style="padding: 0 !important;">
                        <div class="listName newSpanWidth">
                            <div class="spanDiv" v-for="(item, index) in onlyNameArr" :key="index"
                                :style="{ 'lineHeight': clockNameNumberSwitch == 1 ? '' : '48px' }">
                                <span v-if="clockNameNumberSwitch == 1">{{ index + 1 }}</span>
                                {{ item.length > 4 ? item.substring(0, 4) + '...' : item }}
                            </div>
                            <div class="spanDivEmpty"></div>
                            <div class="spanDivEmpty"></div>
                            <div class="spanDivEmpty"></div>
                            <div class="spanDivEmpty"></div>
                            <div class="spanDivEmpty"></div>
                            <div class="spanDivEmpty"></div>
                        </div>
                    </div>
                </div>

            </div>
        </el-drawer>
        <!-- 弹出层-名单导入 -->
        <el-dialog title="Excel表格导入" :visible.sync="importVisible" width="30%" :before-close="importClose">
            <div>
                <el-button @click="downExam">下载excel模板</el-button>
                <el-button type="primary" class="updateFileBtn-out">
                    <input class="updateFileBtn" type="file" id="imageInput7" accept=".xls,.xlsx"
                        @change.stop="importExcel" />导入
                </el-button>
                <div class="b-marT-10" style="color: #F56C6C">注：Excel表格内的内容默认只读取第一列非第一行的内容</div>
            </div>
        </el-dialog>

        <!--抽屉-预存名单列表 -->
        <el-drawer :visible.sync="nameListDrawer" :direction="direction" size="450px" :withHeader="false"
            :before-close="nameListDrawerFun">
            <div class="drawerOutBox">
                <div class="drawer-nav-top">
                    <div></div>
                    <span>预存名单列表</span>
                    <!-- <i class="el-icon-close" @click="nameListDrawerFun"></i> -->
                    <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
                        @click="nameListDrawerFun">
                </div>
                <div class="underline"></div>
                <div class="flex-depart-center b-marT-10 ycn" v-for="(item, index) in presetsList" :key="index"
                    @click="EchoList(item)">
                    <div class="n-name">{{ item.clockPresetTitle }}</div>
                    <div class="n-handle">
                        <span @click.stop="nameLists(item.id)">编辑</span>
                        <span @click.stop="presetsDel(item.id)">删除</span>
                    </div>
                </div>
                <el-button type="primary" class="b-marT-10" round @click="toAddRoster">添加姓名名单</el-button>
            </div>
        </el-drawer>
        <!--抽屉-添加预存名单 -->
        <el-drawer :visible.sync="addNameListDrawer" :direction="direction" size="450px" :withHeader="false"
            :before-close="addNameDrawer">
            <div class="drawerOutBox">
                <div class="drawer-nav-top">
                    <div></div>
                    <span>添加预存名单</span>
                    <!-- <i class="el-icon-close" @click="addNameDrawer"></i> -->
                    <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
                        @click="addNameDrawer">
                </div>
                <div class="underline"></div>
                <div class="nl-title">名单标题</div>
                <div class="b-marT-10">
                    <el-input v-model="clockShowPresetTitle" @input="handlerBlur()" placeholder="请输入内容"></el-input>
                </div>
                <div class="nl-title b-marT-10">预存名单 <span>合计:{{ people_num2 }}人</span></div>
                <div class="b-marT-10">
                    <el-input type="textarea" rows="15" v-model="clockShowPresetContent"
                        placeholder="请输入姓名名单，每个名单可用中英文逗号或换行隔开，最大输入为1000个名单。可复制粘贴" class="textareName"></el-input>
                </div>
                <div class="flex-depart-center b-marT-10">
                    <div class="daoru updateFileBtn-out">
                        从Excel导入
                        <input class="updateFileBtn" type="file" id="imageInput8" accept=".xls,.xlsx"
                            @change.stop="importFiles" />
                    </div>
                    <div class="qingkong" @click="emptyName"><i class="el-icon-delete"></i>清空内容</div>
                </div>
                <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
                    <el-button @click="closeAddNameDrawer">取消</el-button>
                    <el-button type="primary" @click="clockPresetsAdd">确定</el-button>
                </div>
            </div>
        </el-drawer>
        <!--抽屉-接龙后自定义展示页面 -->
        <el-drawer :visible.sync="customizeDrawer" :direction="direction" size="450px" :withHeader="false"
            :before-close="customizeClose">
            <div class="drawerOutBox">
                <div class="drawer-nav-top">
                    <div></div>
                    <span>接龙后自定义展示页面</span>
                    <!-- <i class="el-icon-close" @click="customizeClose"></i> -->
                    <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
                        @click="customizeClose">
                </div>
                <div class="underline"></div>
                <div class="duiHao">
                    <img src="https://ossfastmake.mustke.com//12jielong/lsyJL/successdh.png" alt="">
                </div>
                <div class="b-marT-10 cw">
                    <el-input v-model="copyShowWriting" placeholder="请输入自定义文字"></el-input>
                </div>
                <div class="b-marT-20 flex-depart-center-center" v-if="!copyShowImage">
                    <div class="upl-smallImg upl-smallImg2">
                        <input class="updateFileBtn" type="file" accept="image/*" id="imageInput9"
                            @change="uploadCopyImage" />
                        <i class="el-icon-circle-plus"></i>
                        <span>点击上传图片</span>
                    </div>
                </div>
                <div class="b-marT-20 flex-depart-center-center copy-image-out" v-if="copyShowImage">
                    <img src="https://ossfastmake.mustke.com//static/0307/del.svg" @click.stop="delCopyImage" alt=""
                        class="del-copy-img">
                    <img class="copy-image" :src="imageUrl + copyShowImage" alt="">
                </div>
                <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
                    <el-button @click="customizeDrawer = false">取消</el-button>
                    <el-button type="primary" @click="sureCoverImgFun">确定</el-button>
                </div>
            </div>
        </el-drawer>

        <!--关联接龙-->
        <el-drawer :visible.sync="relatedDrawerShow" :direction="direction" size="450px" :withHeader="false"
            :before-close="relatedDrawerClose">
            <div class="drawerOutBox">
                <div class="drawer-nav-top">
                    <div></div>
                    <span>关联接龙</span>
                    <!-- <i class="el-icon-close" @click="relatedDrawerClose"></i> -->
                    <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
                        @click="relatedDrawerClose">
                </div>
                <div class="underline"></div>
                <div class="call-out" id="scrollable-div">
                    <div class="b-marT-10 bg-gray pad-10" v-for="(item, index) in relatedList" :key="item.value">
                        <div class="flex-depart-center-top">
                            <el-checkbox v-model="item.checked"
                                @change="$event => relateItemChange($event, item, index)"></el-checkbox>
                            <div class="cell-box">
                                <p class="cell-name">{{ item.name }}</p>
                                <div class="cell-addTime">{{ item.add_time }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
                    <el-button @click="relatedDrawerShow = false">取消</el-button>
                    <el-button type="primary" @click="relatedAdd">确定</el-button>
                </div>
            </div>

        </el-drawer>

        <!--属性设置-->
        <el-drawer :visible.sync="propertySetShow" :direction="direction" size="450px" :withHeader="false"
            :before-close="propertyDrawerClose">
            <div class="drawerOutBox drawerOutBox-nopadding gray-bg">
                <div class="drawer-nav-top" style="padding: 0 20px">
                    <div></div>
                    <span>属性设置</span>
                    <!-- <i class="el-icon-close" @click="propertyDrawerClose"></i> -->
                    <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
                        @click="propertyDrawerClose">
                </div>
                <div class="underline"></div>
                <div class="propertySet-box">
                    <!--标题-->
                    <div class="title-block flex-depart-top2">
                        <div class="tb-left font-weight600"><label class="x">*</label>标题</div>
                        <div style="width: 85%">
                            <el-input v-model="propertyData.fieldName" placeholder="请输入内容"></el-input>
                        </div>
                    </div>

                    <!--文本格式-->
                    <div class="wb-setting-block">
                        <div class="zz" v-if="commType == -1 || commType == 9 || commType == 1 || commType == 11 ||
                            commType == 19 || commType == 23 || commType == 24 || commType == 21 || commType == 22 || commType == 25 || commType == 26 ||
                            commType == 27 || commType == 28">
                            <span class="font-weight600">文本格式：</span>
                            <el-select v-model="propertyData.isFormatCheck" placeholder="请选择"
                                @change="formatCheckChange">
                                <el-option v-for="(vItem, vIndex) in validateArr" :key="vIndex" :label="vItem"
                                    :value="vIndex">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="no-repeat"
                            v-if="commType == -1 || commType == 9 || commType == 1 || commType == 11 || commType == 19 || commType == 23 || commType == 24">
                            <div>
                                <div class="no-title">记录唯一性 不可以重复</div>
                                <div class="no-tips">例如学号 工号只能一个接龙者使用。</div>
                            </div>
                            <el-switch v-model="propertyData.isUniqueCheck" active-value="1" inactive-value="0"
                                active-color="#1877FF" inactive-color="rgb(230, 230, 230)">
                            </el-switch>
                        </div>
                    </div>

                    <!--文件数量-->
                    <div class="files-num" v-if="commType == 5">
                        <span class="font-weight600">最多可上传文件数量：</span>
                        <div class="set-box">
                            <el-select v-model="propertyData.imageUploadLimit" placeholder="请选择"
                                @change="imgNumCheckChange">
                                <el-option v-for="(imgItem, imgIndex) in imageUploadNumArr" :key="imgIndex"
                                    :label="imgItem" :value="imgIndex">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <!--单选展示样式-->
                    <div class="files-num" v-if="commType == 2 || commType == 4">
                        <span class="font-weight600">展示样式：</span>
                        <div class="set-box">
                            <el-select v-model="propertyData.displayStyle" placeholder="请选择"
                                @change="imgNumCheckChange">
                                <el-option v-for="(dItem) in displayStyleArr" :key="dItem.value" :label="dItem.label"
                                    :value="dItem.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <!--单选多选-->
                    <div class="radio-block" v-if="commType == 2 || commType == 4">
                        <div class="rb-item" v-for="(contentItem, contentIndex) in propertyData.content"
                            :key="contentIndex">
                            <div class="rb-left">
                                <div>{{ contentIndex + 1 }}</div>
                                <div style="width: 265px;margin-left: 10px"><el-input v-model="contentItem.value"
                                        placeholder="请输入选项名称"></el-input></div>
                            </div>
                            <div class="rb-right">
                                <img :src="commonImgSrc + 'bdJL/move-shang.svg'" @click="upTr(contentIndex)">
                                <img :src="commonImgSrc + 'bdJL/move-xia.svg'" @click="downTr(contentIndex)">
                                <img :src="commonImgSrc + 'bdJL/move-del.svg'" @click="trash(contentIndex)">
                            </div>
                        </div>
                    </div>
                    <div class="radio-add" v-if="commType == 2 || commType == 4">
                        <span @click="addOption">添加选项</span>
                        <span @click="batchOptions">批量添加选项</span>
                    </div>
                    <div class="files-num" v-if="commType == 4">
                        <span class="font-weight600">最多可选：</span>
                        <div class="set-box">
                            <el-select v-model="propertyData.maxValue" placeholder="请选择">
                                <el-option v-for="(mItem, mIndex) in maxValueArr" :key="mIndex" :label="mItem.label"
                                    :value="mItem.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="files-num" v-if="commType == 4">
                        <span class="font-weight600">最少可选：</span>
                        <el-select v-model="propertyData.minValue" placeholder="请选择">
                            <el-option v-for="(mItem, mIndex) in minValueArr" :key="mIndex" :label="mItem.label"
                                :value="mItem.value">
                            </el-option>
                        </el-select>
                    </div>
                    <!--地址格式-->
                    <div class="area-block" v-if="commType == 8">
                        <div class="tt-title">选择格式：</div>
                        <div class="tt-list" v-for="(item, index) in areaSetList" :key="item.type"
                            @click="attributeAreaChange(item.type, index)">
                            <span>{{ item.value }}</span>
                            <img v-if="index != propertyData.areaSelectType"
                                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/no-chose.svg">
                            <img v-if="index == propertyData.areaSelectType"
                                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/has-chose.svg">
                        </div>
                    </div>
                    <!--日期-->
                    <div class="area-block" v-if="commType == 3">
                        <div class="tt-title">选择格式：</div>
                        <div class="tt-list" v-for="(item, index) in timeSetList" :key="item.type"
                            @click="attributeTimeChange(item.type, index)">
                            <span>{{ item.value }}</span>
                            <img v-if="index != propertyData.timeSelectType"
                                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/no-chose.svg">
                            <img v-if="index == propertyData.timeSelectType"
                                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/has-chose.svg">
                        </div>
                    </div>
                    <!--时间区间-->
                    <div class="area-block" v-if="commType == 31">
                        <div class="tt-title">选择格式：</div>
                        <div class="tt-list" v-for="(item, index) in dateSetList" :key="item.type"
                            @click="attributeDateChange(item.type, index)">
                            <span>{{ item.value }}</span>
                            <img v-if="index != propertyData.dateSelectType"
                                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/no-chose.svg">
                            <img v-if="index == propertyData.dateSelectType"
                                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/has-chose.svg">
                        </div>
                    </div>
                    <!--必填/公开-->
                    <div class="bx-block">
                        <div class="bx-item">
                            <el-checkbox v-model="propertyData.isRequiredChecked" @change="checkFun">必填</el-checkbox>
                        </div>
                        <div class="bx-item">
                            <el-checkbox v-model="propertyData.isOpenChecked">公开</el-checkbox>
                        </div>
                    </div>

                    <!--提示-->
                    <div class="tips-block">
                        <div class="tip-title">
                            <span class="font-weight600">提示</span>
                            <el-switch v-model="propertyData.promptSwitch" active-color="#1877FF"
                                inactive-color="rgb(230, 230, 230)" active-value="1" inactive-value="2">
                            </el-switch>
                        </div>
                        <div v-show="propertyData.promptSwitch == 1" class="padding-0-20">
                            <el-divider></el-divider>
                            <div class="tip-t-area">
                                <el-input type="textarea" :rows="4" placeholder="请输入提示内容或说明（选填）" maxlength="50"
                                    v-model="propertyData.promptExplanation">
                                </el-input>
                            </div>
                            <template v-if="propertyData.promptImage">
                                <div class="up-box1">
                                    <input class="updateFileBtn" type="file" id="imageInput11" accept="image/*"
                                        @change="uploadPromptImage" />
                                    <img class="up-img-fun1" :src="imageUrl + propertyData.promptImage" alt="">
                                </div>
                            </template>
                            <template v-if="!propertyData.promptImage">
                                <div class="up-box1">
                                    <input class="updateFileBtn" type="file" id="imageInput10" accept="image/*"
                                        @change="uploadPromptImage" />
                                    <img class="up-img-fun1"
                                        src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/up-img-fun.svg"
                                        alt="">
                                </div>

                            </template>
                        </div>
                    </div>
                </div>
                <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
                    <el-button @click="propertySetShow = false">取消</el-button>
                    <el-button type="primary" @click="propertySet">确定</el-button>
                </div>
            </div>
        </el-drawer>

        <!-- 地图 -->
        <el-dialog title="请选择地址" width="600px" :visible.sync="addressDialog" :destroy-on-close="true" top>
            <iframe id="mapPage2" width="100%" height="100%" style="width: 550px; height:500px" frameborder=0
                src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=NBJBZ-IMQLX-TPL4O-7KADZ-F6HMT-V3BPM&referer=myapp">
            </iframe>
            <span slot="footer">
                <el-button @click="addressDialog = false">取 消</el-button>
                <el-button type="primary" @click="submitMap">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="音乐" width="600px" :visible.sync="musicDialog" :destroy-on-close="true" center>
            <audio controls :src="musicLink" type="audio/mp3"></audio>
        </el-dialog>

        <!--        批量添加选项-->

        <el-dialog title="批量添加选项" :visible.sync="batchOptionShow" width="30%">
            <el-input type="textarea" :rows="8" placeholder="添加选项，一行一个。" maxlength="500" v-model="lineCopywriting">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="batchOptionShow = false">取 消</el-button>
                <el-button type="primary" @click="addLineBreak">确 定</el-button>
            </span>
        </el-dialog>

        <!--名单类型-->
        <el-dialog :visible.sync="nameAddOptionsShow" width="30%" class="no-padding-top" :show-close="false">
            <template slot="title">
                <CustomDialogHeader title="名单类型选择" @close="nameAddOptionsShow = false" />
            </template>
            <div>
                <el-radio-group v-model="nameOrGroup">
                    <el-radio :label="0">不启用</el-radio>
                    <el-radio :label="1">仅添加名单</el-radio>
                    <el-radio :label="2">添加分组 + 名单</el-radio>
                </el-radio-group>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="nameAddOptionsShow = false">取 消</el-button>
                <el-button type="primary" @click="nameAddChange">确 定</el-button>
            </span>
        </el-dialog>


        <!--分组弹框-->
        <el-drawer :visible.sync="subsetShow" :direction="direction" size="450px" :withHeader="false"
            :before-close="subsetDrawerClose">
            <div class="drawerOutBox">
                <div class="drawer-nav-top">
                    <div></div>
                    <span>设置分组</span>
                    <!-- <i class="el-icon-close" @click="subsetDrawerClose"></i> -->
                    <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
                        @click="subsetDrawerClose" />
                </div>
                <div class="underline"></div>
                <div>
                    <div class="flex-depart-center subset-item" v-for="(item, index) in subsetCenterValueArr"
                        :key="index">
                        <div class="flex-depart-left-center sub-left">
                            <img :src="subtractFzImgSrc" @click="subtractFzItem(index)" />
                            <div class="flex-depart-left-center">
                                <div class="cl-name">
                                    {{
                                    item.listGroupName
                                    ? item.listGroupName
                                    : ` 分组${index + 1}`
                                    }}
                                </div>
                            </div>
                        </div>
                        <!--                        <img class="sub-edit" :src="editImgSrc" @click="editFzItem(index,item)">-->
                        <div @click="editFzItem(index, item)" v-if="item.clockInList == ''">
                            <span class="szfz">设置名单</span>
                            <i class="el-icon-arrow-right" style="color: #1877ff"></i>
                        </div>
                        <div @click="editFzItem(index, item)" v-else>
                            <span class="clockNum">{{ item.clockInListNum }}个</span>,<span class="szfz">查看/修改</span>
                            <i class="el-icon-arrow-right" style="color: #1877ff"></i>
                        </div>
                    </div>
                    <div class="flex-depart-center subset-item add-sub">
                        <div class="flex-depart-left-center sub-left" @click="addFzItem">
                            <img :src="addFzImgSrc" />
                            <div>添加分组 </div>
                        </div>
                    </div>
                </div>

                <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
                    <el-button @click="popupSaveFzFn(0)">取消</el-button>
                    <el-button type="primary" @click="popupSaveFzFn(1)">确定</el-button>
                </div>
            </div>
        </el-drawer>

        <!--编辑分组-->
        <el-drawer :visible.sync="handleSubShow" :direction="direction" size="450px" :withHeader="false"
            :before-close="handleSubDrawerClose">
            <div class="drawerOutBox">
                <div class="drawer-nav-top">
                    <div></div>
                    <span>设置分组名单</span>
                    <!-- <i class="el-icon-close" @click="handleSubDrawerClose"></i> -->
                    <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
                        @click="handleSubDrawerClose" />
                </div>
                <div class="underline"></div>

                <div class="setFz-main">
                    <div class="ssfz flex-depart-center">
                        <!-- <span>所属分组</span> -->
                        <div style="width: 100%">
                            <el-input v-model="fzTitle" placeholder="请输入分组名称"></el-input>
                        </div>
                    </div>

                    <div style="position: relative">
                        <el-input type="textarea" :rows="15" placeholder="请输入姓名名单" maxlength="-1"
                            @input="handlerBlurFz($event)" v-model="fzValue"></el-input>
                        <div style="color: #a5a4a4; line-height: 50px">
                            提示：每个名单用逗号或者换行隔开
                        </div>
                        <div class="clockNameNumberSwitchDiv">
                            <div class="flex-depart-center">
                                <el-switch v-model="clockNameNumberSwitch" @change="clockNameNumberSwitchChange($event)"
                                    active-color="#1877FF" inactive-color="rgb(230, 230, 230)" active-value="1"
                                    inactive-value="2"></el-switch>
                                <div style="margin-left: 6px">添加编号/学号</div>
                            </div>

                            <div>合计：<span class="total-count">{{ people_num2 }}</span>人</div>
                        </div>

                    </div>

                    <div class="import-box flex-depart-center">
                        <div class="flex-depart-center">
                            <div class="blueTxt" @click="importVisible = true">
                                从Excel导入
                            </div>
                            <div class="empty flex-depart-center" @click="emptyFn">
                                <i class="el-icon-delete"></i>
                                清空内容
                            </div>
                        </div>
                        <div class="flex-depart-center" @click="openNamelistFun"
                            style="cursor: pointer; color: #1877ff">
                            <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/lsyJL/yucunmingdan.svg"
                                style="margin-right: 5px" />
                            预存名单
                        </div>
                    </div>
                </div>

                <div>
                    <div class="jl-box" :style="{ paddingBottom: '0' }" style="
              margin-bottom: 0 !important;
              margin-top: 0;
              background-color: transparent !important;
            " v-if="onlyGroupArr.length > 0">
                        <div class="jlName" style="padding: 0 !important">
                            <div class="listName newSpanWidth">
                                <div class="spanDiv" v-for="(item, index) in onlyGroupArr" :key="index" :style="{
                                    lineHeight:
                                        activityDetail.clockNameNumberSwitch == 1 ? '' : '48px',
                                }">
                                    <span v-if="activityDetail.clockNameNumberSwitch == 1">{{
                                        index + 1
                                        }}</span>
                                    {{ item.length > 4 ? item.substring(0, 4) + "..." : item }}
                                </div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
                    <el-button @click="addOrEditFz(0)">取消</el-button>
                    <el-button type="primary" @click="addOrEditFz(1)">确定</el-button>
                </div>
            </div>
        </el-drawer>

        <!--弹框-补卡次数-->
        <el-dialog title="请输入补卡次数" :visible.sync="disbandBox" width="30%">
            <el-input type="text" placeholder="请输入补卡次数" maxlength="500" v-model="clockSupplyCenterText">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="disbandBox = false">取 消</el-button>
                <el-button type="primary" @click="confirmModal">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="提示" :visible.sync="isDelSignInfoPop" width="30%" :before-close="handleClose">
            <span>原有填表项内容已修改，会删除所有已报名人员信息，请提醒接龙人员重新参与报名</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isDelSignInfoPop = false">取 消</el-button>
                <el-button type="primary" @click="confirmChangeForm">确 定</el-button>
            </span>
        </el-dialog>
        <!--  演示  -->
        <el-dialog :title="contentList.title" :visible.sync="demonVisible" width="450px" :show-close="false">
            <template slot="title">
                <CustomDialogHeader title="演示" @close="demonVisible = false" />
            </template>
            <div style="max-height: 700px; overflow-y: auto">
                <img class="usePopImg" :src="contentList.imgurl" alt="" />
            </div>
        </el-dialog>
    </Layout>
</template>
<style lang="scss" scoped>
.b-marT-10 {
    margin-top: 10px;
}

.b-marT-20 {
    margin-top: 20px;
}

/* flex布局 */
.flex-depart-left {
    display: flex;
    align-items: center;
}

.flex-depart-center {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.flex-depart-center-center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.flex-depart-center-end {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.flex-depart-top {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}

.flex-depart-left-warp {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.flex-depart-center-top {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.flex-depart-left-center {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

/*大图排序*/
.flex-depart-column-top-left {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}

.clockNameNumberSwitchDiv {
    display: flex;
    /*margin-top: 10px;*/
}

.outBox {
    width: 1000px;
    margin: 0 auto;
    background-color: #FBFBFB;
}

.bigTitle {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #367ce0;
    /*font-weight: bold;*/
    background-color: #FBFBFB;
}

.block-title {
    font-size: 14px;
    font-weight: Bold;
    text-align: left;
    color: #191919;
}

.blockBox {
    padding: 15px;
    background-color: white;
    margin-bottom: 10px;
    position: relative;
}

.cannot-edit {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    height: 100%;
    width: 100%;
}

.handle-box {
    display: inline-block;
}

.handle-box .h-item {
    margin-right: 30px;
    cursor: pointer;
    display: inline-block;
    float: left;
    margin-top: 8px;
}

.handle-box .h-item img {
    width: 20px;
    height: 20px;
    margin-right: 1px;
}

.handle-box .h-item span {
    font-size: 14px;
    color: #767d98;
    cursor: pointer;

    &:hover {
        color: #1877ff;
    }
}

.addBtnStyle {
    width: 200px;
    height: 40px;
    background: #ffffff;
    border: 1px dashed #4a73f7;
    border-radius: 23px;
    font-size: 14px;
    color: #1877ff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    i {
        margin-right: 10px;
    }
}

.f-block {
    background: #fafafa;
    border-radius: 2px;
    box-sizing: border-box;
    /*padding: 10px;*/
    margin-top: 10px;
    overflow: hidden;
}

.f-block:last-child {
    /*margin-bottom: 0;*/
}

.tl-item .f-ipt {
    width: 700px;
}

.f-handle img {
    width: 20px;
    height: 20px;
    margin-left: 5px;
    cursor: pointer;
}

.checkedState .el-checkbox {
    margin-bottom: 0;
}

.ch-copy {
    margin-left: 50px;
    font-size: 13px;
    color: #409EFF;
    align-items: center;
    cursor: pointer;

    i {
        /*width: 17px;*/
        /*height: 17px;*/
        margin-right: 4px;
    }

}

.selectBox-item {
    padding-left: 20px;
}

.selectBox-item .el-input {
    width: 700px;
    margin-right: 10px;
}

.selectBox-item i {
    font-size: 18px;
}

.addOptStyle {
    color: #1877ff;
    cursor: pointer;
    padding-left: 20px;
}

.settingBox {
    padding: 10px 15px;
    background-color: white;
    position: relative;
}

.sTitle {
    font-size: 14px;
    font-weight: Bold;
    text-align: left;
    color: #191919;
    display: inline-flex;
    align-items: center;

    label {
        font-size: 12px;
        color: grey;
        font-weight: normal;
    }

    b {
        width: 4px;
        height: 14px;
        background: #1877ff;
        border-radius: 2px;
        margin-right: 5px;
    }
}

.settingBox .el-date-editor .el-range-separator {
    width: 15%;
}

.setText {
    color: #1877ff;
    cursor: pointer;
    text-decoration: underline;
}

.settingBox .el-radio {
    margin-bottom: 0;
}

.block-for-box {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    width: 100%;
    padding: 10px;
    margin-top: 10px;
}

.big-img img {
    max-width: 600px;
    height: auto;
}

.b-handle img {
    width: 20px;
    height: 20px;
    margin: 5px;
    cursor: pointer;
}

.addSmallBtn {
    width: 100%;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #F7F7F7;
    color: #1877ff;
    border-radius: 4px;
    position: relative;
    cursor: pointer;

}

.updateFileBtn {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}

.rangeTimes i {
    margin-left: 5px;
    font-size: 25px;
    cursor: pointer;
    color: #F56C6C;
}

.add-rangeTimes {
    color: #1877ff;
    cursor: pointer;
}

.map {
    width: 100%;
    height: 300px;
}

.deadline {
    width: 80px;
    margin-left: 5px;
}

.smallImgbox {
    width: 150px;
    height: 150px;
    background-color: #F7F7F7;
    margin: 5px;
    position: relative;
}

.handle2 {
    width: 150px;
    height: 150px;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    display: none;

    img {
        width: 20px;
        height: auto;
        cursor: pointer;
        margin-top: 70px;
        margin-left: 33px;
    }
}

.seeBigImgHover:hover {
    .handle2 {
        display: block;
    }
}

.imgBg {
    width: 150px;
    height: 150px;
    /*background: url("https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg") no-repeat center;*/
    background-size: cover;

}

.upl-smallImg {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 150px;
    background-color: #F7F7F7;
    color: #1877ff;
    cursor: pointer;
    margin: 5px;
    position: relative;

    i {
        font-size: 26px;
    }
}

.upl-smallImg2 {
    width: 100%;
    height: 200px;
    margin: 0;
}

.filesStyle {
    height: 45px;

    .tubiao {
        margin-right: 2px;
    }

    .del {
        margin-left: 10px;
        position: relative;
        top: 1px;
        cursor: pointer;
    }

    img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
    }
}

.previewImgBox {
    width: 100%;
    height: 100%;
    z-index: 99999;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .inner-p-img {
        height: 600px;
        width: auto;
    }

    .closePImg {
        font-size: 40px;
        cursor: pointer;
        position: fixed;
        top: 40px;
        right: 40px;
        color: white;
    }
}

.drawerOutBox {
    padding: 0 20px;
    height: 100%;
    position: relative;
}

.drawBottomBtn {
    width: 100%;
    height: 70px;
    position: absolute;
    left: 0;
    bottom: 0;
    box-sizing: border-box;
    padding-right: 20px;
}

.af-title {
    font-weight: bold;
}

.ty-b-item {
    position: relative;
    width: 195px;
    height: 80px;
    border: 1px solid #B2C4FB;
    background-color: #F4F7FE;
    border-radius: 5px;
    box-sizing: border-box;
    padding-top: 18px;
    padding-left: 10px;
    cursor: pointer;
}

.ty-b-item div {
    font-weight: bold;
    color: #1877FF;
}

.addFBtn {
    color: #1877FF;
    font-size: 22px;
    position: absolute;
    right: 10px;
    top: 18px;
}

.cy-box {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
}

.cy-item {
    width: 128px;
    height: 45px;
    box-sizing: border-box;
    padding: 0 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #F4F7FE;
    border-radius: 5px;
    margin-bottom: 5px;
    cursor: pointer;

    .addFBtn2 {
        color: #1877FF;
        font-size: 22px;
    }
}

.seniorStyle {
    background-color: #ECF4FF !important;
    cursor: pointer;
}

.cus-dates {
    margin-bottom: 0 !important;
    margin-left: 5px;
}

.nl-title {
    font-weight: bold;
    margin-top: 10px;

    span {
        font-size: 12px;
        font-weight: normal;
        color: grey;
    }
}

.daoru {
    color: #1877FF;
    cursor: pointer;
    position: relative;
    text-decoration: underline;
}

.qingkong {
    cursor: pointer;
    color: red;
}

.ycn {
    width: 100%;
    padding: 10px;
    border-radius: 4px;
    box-sizing: border-box;
    background-color: #FBFBFB;
    border: 1px solid #d4d4d4;

    .n-name {
        width: 50%;
        word-break: break-word;
    }

    .n-handle {
        span {
            color: #1877FF;
            margin-left: 10px;
            cursor: pointer;
        }
    }
}

.duiHao {
    text-align: center;
    margin-top: 10px;

    img {
        height: 80px;
        width: 80px;
    }
}

.updateFileBtn-out {
    position: relative;
}

.copy-image-out {
    position: relative;
}

.del-copy-img {
    width: 30px;
    height: 30px;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
}

.copy-image {
    width: 100%;
    height: auto;
}

.posi-bottom-btn-box {
    position: fixed;
    left: 130px;
    right: 0;
    bottom: 0;
    height: 74px;
    z-index: 999;
    background: #fff;
}

.saveDatabox {
    width: 300px;
    height: 45px;
    background: #1877ff;
    border-radius: 25px;
    font-size: 16px;
    font-weight: Bold;
    color: #ffffff;
    cursor: pointer;
    border: 2px solid #1877ff;
}

.yl {
    width: 120px;
    height: 50px;
    background: #fff;
    border-radius: 25px;
    font-size: 16px;
    font-weight: Bold;
    color: #666464;
    border: 1px solid #666464;
    cursor: pointer;
    margin-right: 10px;
}

.s-name-item {
    width: 105px;
    height: 45px;
    background: #f2f2f2;
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    line-height: 45px;
    margin-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
}

.set-out-box {
    position: relative;
    height: auto;
}

.centerTitle input {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    /*transition: border-color .2s cubic-bezier(.645,.045,.355,1);*/
    width: 100%;
}

.centerTitle input:focus {
    border-color: #409EFF;
}

.centerTitle input::-webkit-input-placeholder {
    /* placeholder颜色 */
    color: #C4C4CC;
    /* placeholder字体大小 */
    font-size: 14px;
}

.centerTitle {}

.addnameBtns button {
    width: 45%;
}

.el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 5px 0;
}

.hoverColor1:hover {
    background-color: #fafafa;
}

.hoverColor1:hover .del {
    color: red;
}

.drawer-nav-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;

    span {
        font-size: 18px;
        color: black;
        font-weight: bold;
    }

    i {
        cursor: pointer;
        font-size: 18px;
    }
}

.underline {
    width: 100%;
    height: 0.5px;
    background: #e7e7e7;
}

.close-btn {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.danwei {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;

    /*display: inline-block;*/
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    width: 210px;

    input {
        color: #606266;
        width: 170px;
        height: 38px;
        border: 0;
        outline: none;
        box-sizing: border-box;
        padding-left: 10px;
        /*background-color: red;*/
    }
}

.set-out-box .settingBox:hover {
    background-color: #f4f4f4;
}

.blockBox {}

.settingBox {}

.danwei:hover {
    border: 1px solid #409EFF !important;
}

.el-input {}

.bf-item {}

.bf-item {}

.zsy {}

.nozsy {}

.gl-btnStyle {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #1877ff;
    background-color: rgba(247, 247, 247, 1);
    cursor: pointer;
}

.gljl-block {
    height: 45px;
}

.gljl-block:hover {
    background-color: #f4f4f4;
}

.cell-box {
    margin-left: 10px;
}

.cell-name {
    margin-bottom: 5px;
    font-weight: bold;
}

.cell-addTime {
    font-size: 12px;
}

.bg-gray {
    background-color: #f5f5f5;
}

.pad-10 {
    padding: 10px;
}

.call-out {
    height: calc(100% - 190px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    /* 增加 iOS 滚动支持 */
    padding-bottom: 20px;
    /* 增加底部填充,确保有足够空间触发滚动 */
}

.flex-depart-leftStart {
    display: flex;
    justify-content: flex-start;
}

.inner-main-box {
    width: 96.5%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 10px 10px;

}

.left-ttype {
    width: 3.5%;
    background: #c2dbff;
    font-size: 12px;
    color: #466aa9;
    writing-mode: vertical-rl;
    display: flex;
    justify-content: center;
    align-items: center;
    letter-spacing: 2px;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
}

.propertySet-box {
    .bx-item {
        width: 49%;
        background-color: white;
        height: 60px;
        box-sizing: border-box;
        padding: 0 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .bx-item .el-checkbox {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-flow: row-reverse;
        margin-bottom: 0;
    }

    .flex-depart-top2 {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .x {
        color: red;
    }

    .title-block {
        background-color: white;
        padding: 10px;
        border-top: 0.5px solid #E5E5E5;
    }

    .tb-left {
        color: #555555;
        font-size: 15px;
        display: flex;
        align-items: center;
    }

    .zz {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 65px;
        border-bottom: 1px solid #eee;
        padding-left: 10px;
        padding-right: 10px;

        text {
            color: #555555;
            font-size: 15px;
        }
    }

    .zz-picker {
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding-left: 10px;
        padding-right: 10px;
        width: 214px;
        height: 44px;
        background: #f4f4f4;
        border-radius: 5px;

        image {
            width: 20px;
            height: 20px;
        }
    }

    .no-repeat {
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding-left: 10px;
        padding-right: 10px;
        height: 80px;
    }

    .wb-setting-block {
        background-color: white;
        margin-top: 10px;
    }

    .no-title {
        font-size: 14px;
        font-weight: bold;
        text-align: left;
        color: #555555;
    }

    .no-tips {
        font-size: 13px;
        text-align: left;
        color: #7c838e;
    }

    .bx-block {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .tips-block {
        margin-top: 10px;
        background-color: white;
        padding-bottom: 10px;
    }

    .tip-title {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: white;

        text {
            color: #555555;
            font-size: 15px;
        }
    }

    .tip-t-area {
        margin-top: 10px;
    }

    .up-img-fun {
        margin-top: 7px;
        width: 100px;
        height: 100px;
        background: #f4f4f4;
        border-radius: 5px;
    }

    .footerBtn {
        height: 63px;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 9999;
        padding-left: 10px;
        padding-right: 10px;
        padding-bottom: calc(-18.5px + env(safe-area-inset-bottom));

        .btn {
            width: 340px;
            height: 40px;
            background-color: #1877FF;
            border-radius: 25px;
            text-align: center;
            line-height: 40px;
            color: white;
            font-size: 16px;
        }
    }

    .files-num {
        background-color: white;
        padding: 15px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        margin-top: 10px;

        text {
            color: #555555;
            font-size: 15px;
        }
    }

    .radio-block {
        width: 94%;
        margin: 10px auto;
        background-color: white;
        border-radius: 4px;
        box-sizing: border-box;
        padding: 0 10px;
    }

    .rb-item {
        padding-top: 12.5px;
        padding-bottom: 12.5px;
        display: flex;
        justify-content: space-between;
        border-bottom: 0.5px solid #E5E5E5;
    }

    .rb-left {
        width: 75%;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        view {
            width: 14px;
            height: 14px;
            background: #e2e2e2;
            border: 0.5px solid #cbcbcb;
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #8f8f8f;
            font-size: 12px;
        }

        input {
            width: 88%;
            margin-left: 10px;
        }
    }

    .rb-right {
        width: 25%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        img {
            width: 24px;
            height: 24px;
        }
    }

    .radio-add {
        margin: 0 auto;
        padding: 0 10px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
            color: #477aff;
            font-size: 14px;
            cursor: pointer;
        }
    }

    .area-block {
        margin-top: 10px;
        background-color: white;
        box-sizing: border-box;
        padding: 0 10px;
    }

    .tt-list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 22.5px;
        border-bottom: 0.5px solid #E7E7E7;
        font-size: 7px;
        width: 96%;
        margin: 0 auto;

        img {
            width: 8px;
            height: 8px;
            flex-shrink: 0;
        }
    }

    .tt-title {
        font-size: 7px;
        font-weight: bold;
        color: #555555;
        line-height: 25px;
        border-bottom: 0.5px solid #E7E7E7;
    }

    .position-block {
        margin-top: 5px;
        background-color: white;
        box-sizing: border-box;
        padding: 7.5px 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .position-title {
        display: flex;
        color: #555555;
        font-size: 7.5px;
        align-items: center;

        img {
            width: 7.5px;
            height: 7.5px;
            flex-shrink: 0;
            margin-left: 5px;
        }
    }

    .popComm {
        background-color: white;
        border-radius: 5px;
        width: 160px;
        padding-bottom: 7.5px;
    }

    .close-xsxq {
        position: absolute;
        right: 5px;
        top: 7.5px;

        img {
            height: 10px;
            width: 10px;
        }
    }

    .tishi-title {
        line-height: 25px;
        border-bottom: 0.5px solid #eee;
        font-weight: 600;
        font-size: 8px;
        text-align: center;
        color: #333;
    }

    .center-content {
        width: 92%;
        margin: 5px auto;

        textarea {
            width: 100%;
            height: 125px;
            background: #f4f4f4;
            border: 0.5px solid #dcdde0;
            border-radius: 2px;
            box-sizing: border-box;
            padding: 5px;
        }
    }

    .popComm .btn1 {
        width: 105px;
        height: 20px;
        background: #4a73f8;
        border-radius: 11.25px;
        color: white;
        text-align: center;
        line-height: 20px;
        margin: 0 auto;
    }

    .reject-con {
        width: 160px;
        background: #ffffff;
        border-radius: 4px;
        overflow: hidden;
        position: relative;

        .studybtn {
            height: 23.25px;
            border: 0.25px solid #e4e4e4;
            border-radius: 0px 0px 4px 4px;
            line-height: 23.25px;
            text-align: center;
            font-size: 7.5px;
            color: #4A73F8;
        }

        .top-title {
            height: 22.5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: 0.5px solid #E7E7E7;

            text {
                font-size: 9px;
                font-weight: bold;
                color: #2b2f36;
            }

            .re-close {
                position: absolute;
                right: 5px;
                top: 7.25px;
            }
        }
    }

    .invite-txt1 {
        height: 42.5px;
        display: flex;
        justify-content: center;
        align-items: center;

        view {
            font-size: 7px;
            text-align: center;
            color: #555555;
        }

        input {
            width: 140px;
            height: 22px;
            background: #f4f4f4;
            border: 0.5px solid #dcdde0;
            border-radius: 2px;
            box-sizing: border-box;
            padding-left: 5px;
            line-height: 22px;
        }
    }

    .copyTA-Style {
        padding: 4px;
        color: grey;
        font-size: 7.5px;
    }

    .copyTA-Style-nodata {
        padding: 4px;
        color: #adadad;
        font-size: 7.5px;
    }
}


.sxsz {
    font-size: 13px;
    color: #1877ff;
    cursor: pointer;
}

.drawerOutBox-nopadding {
    padding: 0;
}

.gray-bg {
    background-color: #f5f5f5;
}

.drawerOutBox-nopadding .drawer-nav-top {
    background-color: white;
}

.padding-0-20 {
    padding: 0 10px;
}

.up-img-fun1 {
    width: 50px;
    height: auto;
    margin-top: 3.5px;
}

.up-box1 {
    margin-top: 3.5px;
    width: 50px;
    height: 50px;
    background: #f4f4f4;
    border-radius: 2.5px;
    overflow: hidden;
    position: relative;
}

/*    分组名单*/
.subsetBox {
    box-sizing: border-box;
    padding: 15px 10px;
    padding-bottom: 0;
}

.bd-popTitle {
    color: black;
    text-align: center;
}

.subset-item {
    padding: 15px 0px;
    border-bottom: 1px solid #eee;
    width: 94%;
    margin: 0 auto;
}

.sub-left img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
    cursor: pointer;
}

.sub-left .cl-name {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    width: 220px;
}

.sub-edit {
    width: 17.5px;
    height: 17.5px;
    cursor: pointer;
}

.add-sub {
    color: #1877ff;
    border-bottom: 0;
    cursor: pointer;
}

.setFz-main {
    margin-top: 15px;
}

.ssfz {
    border-radius: 4px;
    margin-bottom: 10px;
    box-sizing: border-box;
}

.import-box {
    font-size: 14px;
    margin-top: 12px;

    img {
        height: 15px;
        width: 15px;
    }
}

.blueTxt {
    color: #1877ff;
    cursor: pointer;
}

.import-box .empty {
    margin-left: 10px;
    cursor: pointer;
}

.yl16 {
    text-align: center;
    font-size: 12px;
    color: grey;
    margin-top: 15px;
    margin-bottom: 10px;
}

.fz-select-box {
    border-radius: 4px;
    border: 1px solid #dadbde !important;
    margin: 0px auto 10px;
    box-sizing: border-box;
    padding: 10px;
    background-color: white;
    width: 96%;
}

.jlName {
    margin: 0 auto 0 auto;
    border-radius: 5rx;
    background-color: #fff;

    .listName {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
        margin-top: 10px;

        .spanDiv {
            height: 50px;
            width: 10%;
            margin: 4px;
            background-color: #F2F2F2;
            border-radius: 4px;
            text-align: center;
            font-size: 12px;
            color: #626974;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

        }

        .spanDivEmpty {
            height: 0px;
            width: 10%;
            margin: 4px;
        }

    }

    .tips {
        font-size: 14px;
        text-align: center;
        color: #333;
        padding: 0 15px;
    }

}

.mar-bot-check-0 .el-checkbox {
    margin-bottom: 0;
}

.cannotEditStyle {
    padding-top: 10px;
    padding-bottom: 10px;
    color: #ff0000;
    font-size: 15px;
}

.jl-box {
    background-color: #EBEEF2;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding-bottom: 10px;
    margin-top: 16px;

    .jl-title {
        height: 57px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 17px;
        font-weight: bold;
        width: 94%;
        margin: 0 auto;
        color: #323B5A;

    }

    .jlName {
        /*width: 690rpx;*/
        margin: 0 auto 0 auto;
        border-radius: 5px;
        background-color: #fff;
        padding: 12px 8px 12px 8px;

        .listName {
            display: flex;
            flex-wrap: wrap;
            margin-top: 10px;
            padding: 10px;

            .span {
                height: 47px;
                flex: 0 0 23%;
                margin-bottom: 6px;
                background-color: #F2F2F2;
                border-radius: 4px;
                margin-right: calc(10% / 4);
                text-align: center;
                // line-height: 95rpx;
                font-size: 12px;
                color: #626974;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
            }


            .span:nth-child(4n) {
                margin-right: 0;

            }

        }

        .tips {
            font-size: 14px;
            text-align: center;
            color: #333;
            padding: 0 15px;
        }

    }
}

.newSpanWidth .spanDiv {
    width: 15% !important;
}

.newSpanWidth .spanDivEmpty {
    height: 0px;
    width: 15% !important;
    margin: 4px;
}

::v-deep .el-input__inner {
    color: black;
}

::v-deep .el-textarea__inner {
    color: black;
}

.autograph-row {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

.autograph-label {
    font-weight: bold;
    margin-right: 12px;
    white-space: nowrap;
}

.autograph-input-wrap {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
}

.autograph-input {
    width: 100%;
    text-align: right;
}

.autograph-placeholder {
    position: absolute;
    right: 36px;
    color: #bfbfbf;
    pointer-events: none;
}

.autograph-edit {
    position: absolute;
    right: 10px;
    color: #909399;
    cursor: pointer;
    font-size: 18px;
}
.name-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
  .flex-left {
    display: flex;
    align-items: center;
  }
  .flex-right {
    display: flex;
    align-items: center;
  }
  .flex-dropdown {
    margin-left: 10px;
  }
}
.yanshiBtn {
  width: 60px;
  height: 15px;
}

.clockNameNumberSwitchDiv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  //margin-top: 10px;
}


.name-row-num {
  position: relative;
}
.usePopImg {
  width: 400px;
  height: auto;
}

.yanshiBtn {
  cursor: pointer;
}
.name-title-left {
  display: flex;
}
.name-title-left span {
  color: #191919;
  font-weight: bold;
}

.szfz {
  color: #1877ff;
  font-size: 14px;
  cursor: pointer;
}
.add-tools {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #1877ff;
  margin-left: 8px;
  cursor: pointer;
  .add-tools-item {
    display: flex;
    align-items: center;
  }
  .add-tools-item-text {
    margin-left: 5px;
  }
}

</style>
